<template>
    <div>
        <el-card shadow="never" class="order-workbench">
            <div slot="header" class="order-workbench__header">
                <div v-if="showTitle" class="order-workbench__title">{{ title }}</div>
                <div class="order-workbench__toolbar" :class="{ 'order-workbench__toolbar--titled': showTitle }">
                    <div
                        v-if="hasToolbarLeading"
                        class="order-workbench__toolbar-leading"
                    >
                        <el-button
                            v-if="showCreateButton && !hidePrimaryActions"
                            type="primary"
                            size="small"
                            class="order-workbench__create-btn"
                            @click="openCreateDialog"
                        >
                            新增
                        </el-button>
                        <el-button
                            v-if="showCreateButton && !hidePrimaryActions"
                            type="primary"
                            size="small"
                            class="order-workbench__create-btn"
                            @click="openEditDialogFromToolbar"
                        >
                            修改
                        </el-button>
                        <el-button
                            v-if="showFieldWorkToolbarButton"
                            type="primary"
                            size="small"
                            class="order-workbench__create-btn"
                            @click="openWorkDialogFromToolbar"
                        >
                            外勤
                        </el-button>
                        <el-button
                            v-if="showDispatchToolbarButton"
                            type="primary"
                            size="small"
                            class="order-workbench__create-btn"
                            @click="openDispatchDialogFromToolbar"
                        >
                            派单
                        </el-button>
                        <span v-if="showDispatchToolbarSelectionHint && selectedOrderRow && selectedOrderRow.id" class="order-workbench__selected-hint">
                            已选：{{ (selectedOrderRow.company && selectedOrderRow.company.name) || selectedOrderRow.order_no || ('订单#' + selectedOrderRow.id) }}
                        </span>
                    </div>
                    <div
                        class="order-workbench__toolbar-actions"
                        :class="{ 'order-workbench__toolbar-actions--stretch': !hasToolbarLeading }"
                    >
                        <el-button
                            type="primary"
                            size="small"
                            class="order-workbench__create-btn order-workbench__entry-btn--qcc"
                            style="margin: 0"
                            @click="openSystemEntryPortal('qcc')"
                        >
                            查一查
                        </el-button>
                        <el-button
                            type="primary"
                            size="small"
                            class="order-workbench__create-btn"
                            style="margin: 0"
                            @click="openSystemEntryPortal('bjzs')"
                        >
                            报价助手
                        </el-button>
                        <el-button
                            type="primary"
                            size="small"
                            class="order-workbench__create-btn order-workbench__entry-btn--national-tax"
                            style="margin: 0"
                            @click="openSystemEntryPortal('nationalTax')"
                        >
                            电子税务局
                        </el-button>
                        <el-button
                            type="primary"
                            size="small"
                            class="order-workbench__create-btn order-workbench__entry-btn--publicity"
                            style="margin: 0"
                            @click="openSystemEntryPortal('publicity')"
                        >
                            企业信用公示
                        </el-button>
                        <el-button
                            v-if="isArchivedListTable"
                            type="success"
                            size="small"
                            class="order-workbench__create-btn"
                            :loading="archivedBasicExporting"
                            @click="exportArchivedOrdersBasic"
                        >
                            导出
                        </el-button>
                        <el-date-picker
                            v-if="isPublicityTable"
                            v-model="filters.publicity_end_date"
                            type="date"
                            value-format="yyyy-MM-dd"
                            size="small"
                            clearable
                            placeholder="公示结束时间"
                            class="order-workbench__date-filter"
                            @change="fetchOrders"
                        />
                        <el-input
                            v-model.trim="filters.keyword"
                            size="small"
                            clearable
                            placeholder="公司名称、信用机构代码证搜索"
                            class="order-workbench__search app-search-input"
                            :style="{ width: searchInputWidth + 'px' }"
                            @keyup.enter.native="fetchOrders"
                        >
                            <el-button slot="append" icon="el-icon-search" @click="fetchOrders" />
                        </el-input>
                        <el-button size="small" @click="resetToolbarSearch">重置</el-button>
                    </div>
                </div>
            </div>
            <el-table
                ref="ordersTableRef"
                v-loading="loading"
                :data="displayedOrders"
                border
                stripe
                :fit="autoColumnWidth"
                highlight-current-row
                :row-class-name="getRowClassName"
                :row-style="getRowStyle"
                :header-cell-style="{ textAlign: 'center' }"
                :cell-style="{ textAlign: 'center' }"
                class="order-workbench__table"
                :class="{ 'order-workbench__table--auto': autoColumnWidth }"
                @row-click="handleOrderRowClick"
                @cell-dblclick="handleOrderCellDblClick"
            >
                <el-table-column label="日期" :width="resolveColumnWidth(72, true, 'date')">
                    <template slot-scope="{ row }">
                        {{ listDisplayDate(row) }}
                    </template>
                </el-table-column>

                <el-table-column
                    label="公司名称"
                    :width="resolveColumnWidth(200, false, 'company_name')"
                    :min-width="resolveColumnMinWidth(180)"
                    class-name="order-workbench-col--company-name"
                >
                    <template slot-scope="{ row }">
                        <div class="order-workbench__company-name-cell">
                            <el-tooltip
                                v-if="showDispatchToolbarButton && hasFieldBadge(row)"
                                :content="fieldBadgeTooltip(row)"
                                placement="top"
                                effect="dark"
                                :open-delay="400"
                            >
                                <span class="order-workbench__badge-tooltip-trigger">
                                    <el-tag
                                        type="warning"
                                        size="mini"
                                        effect="plain"
                                        class="order-workbench__field-badge"
                                    >
                                        勤
                                    </el-tag>
                                </span>
                            </el-tooltip>
                            <!-- v-if="showDispatchToolbarButton && hasDispatchBadge(row) && !isWorkbenchSubaccount" -->
                            <el-tooltip
                                v-if="companyNameDispatchPaiVisibleForRow(row)"
                                :content="dispatchBadgeTooltip(row)"
                                placement="top"
                                effect="dark"
                                :open-delay="400"
                            >
                                <span class="order-workbench__badge-tooltip-trigger">
                                    <el-tag
                                        type="info"
                                        size="mini"
                                        effect="plain"
                                        class="order-workbench__dispatch-badge"
                                    >
                                        派
                                    </el-tag>
                                </span>
                            </el-tooltip>
                            <copyable-field :value="row.company && row.company.name" />
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    label="统一信用代码"
                    :width="resolveColumnWidth(110, false, 'credit_code')"
                    :min-width="resolveColumnMinWidth(150)"
                    class-name="order-workbench-col--credit-code"
                >
                    <template slot-scope="{ row }">
                        <copyable-field :value="row.company && row.company.credit_code" />
                    </template>
                </el-table-column>

                <el-table-column label="姓名" :width="resolveColumnWidth(40, false, 'legal_name')">
                    <template slot-scope="{ row }">
                        <copyable-field :value="row.company && row.company.legal_name" />
                    </template>
                </el-table-column>

                <el-table-column
                    label="法人身份证"
                    :width="resolveColumnWidth(150, false, 'legal_id_no')"
                    :show-overflow-tooltip="!isTaxClearedMainPage"
                >
                    <template slot-scope="{ row }">
                        <copyable-field :value="row.company && row.company.legal_id_no" />
                    </template>
                </el-table-column>

                <el-table-column
                    label="法人手机号"
                    :width="resolveColumnWidth(50, false, 'phone')"
                    :show-overflow-tooltip="!isTaxClearedMainPage && !isTodoTable && !isPublicityTable && !isReviewListTable && !isRejectResubmitListTable"
                >
                    <template slot-scope="{ row }">
                        <div class="order-workbench__cell-center">
                            <copyable-field :value="row.company && row.company.phone" />
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    v-if="isArchivedListTable"
                    label="税务进度"
                    :width="resolveColumnWidth(76, false, 'archived_tax_progress')"
                >
                    <template slot-scope="slotProps">
                        <span class="order-workbench__tax-progress-cell">已清税</span>
                    </template>
                </el-table-column>

                <el-table-column
                    v-if="isArchivedListTable"
                    label="工商进度"
                    :width="resolveColumnWidth(76, false, 'archived_biz_progress')"
                >
                    <template slot-scope="slotProps">
                        <span class="order-workbench__tax-progress-cell">已注销</span>
                    </template>
                </el-table-column>

                <el-table-column v-if="isTaxClearedBizColumnsTable" label="工商情况" :width="resolveColumnWidth(50, false, 'biz_announcement_status')" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        <el-tooltip
                            v-if="bizSituationTooltipText(row)"
                            :content="bizSituationTooltipText(row)"
                            placement="top"
                            effect="dark"
                        >
                            <span class="order-workbench__tax-progress-cell order-workbench__tax-progress-cell--hint">
                                {{ formatBizAnnouncementLabel(row.biz_announcement_status) }}
                            </span>
                        </el-tooltip>
                        <span v-else>{{ formatBizAnnouncementLabel(row.biz_announcement_status) }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-else-if="!isPublicityTable && !isArchivedListTable" label="税务情况" :width="resolveColumnWidth(76, false, 'tax_account_status')" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        {{ formatTaxAccountStatusLabel(row.tax_account_status) }}
                    </template>
                </el-table-column>
                <el-table-column v-if="!isTaxClearedTable && !isPublicityTable && !isPendingSubmitTable && !isArchivedListTable" label="税登方式" :width="resolveColumnWidth(76, false, 'tax_login_mode')" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        {{ row.tax_login_mode || '--' }}
                    </template>
                </el-table-column>


                <el-table-column v-if="isTaxClearedBizColumnsTable" label="年报情况" :width="resolveColumnWidth(50, false, 'annual_report_stage')" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        {{ formatAnnualReportStageLabel(row.annual_report_stage) }}
                    </template>
                </el-table-column>
                <el-table-column v-if="isTaxClearedBizColumnsTable" label="执照情况" :width="resolveColumnWidth(50, false, 'biz_license_status')" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        {{ formatBizLicenseLabel(row.biz_license_status) }}
                    </template>
                </el-table-column>

                <el-table-column v-if="isTaxClearedBizColumnsTable" label="工商进度" :width="resolveColumnWidth(50, false, 'biz_progress_status')">
                    <template slot-scope="{ row }">
                        <el-tooltip
                            v-if="bizProgressTooltipText(row)"
                            placement="top"
                            effect="dark"
                            popper-class="order-workbench__note-tooltip"
                        >
                            <span class="order-workbench__tax-progress-cell order-workbench__tax-progress-cell--hint">
                                {{ displayBizProgressLabel(row) }}
                            </span>
                            <div slot="content" class="order-workbench__note-tooltip-content">{{ bizProgressTooltipText(row) }}</div>
                        </el-tooltip>
                        <span v-else class="order-workbench__tax-progress-cell">{{ displayBizProgressLabel(row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-else-if="isPendingSubmitStyleTable"
                    label="工商进度"
                    :width="resolveColumnWidth(76, false, 'biz_progress_status')"
                >
                    <template slot-scope="{ row }">
                        <el-tooltip
                            v-if="bizProgressTooltipText(row) && !isPendingSubmitTable && !isRejectResubmitListTable && !isReviewListTable"
                            placement="top"
                            effect="dark"
                            popper-class="order-workbench__note-tooltip"
                        >
                            <span class="order-workbench__tax-progress-cell order-workbench__tax-progress-cell--hint">
                                {{ displayBizProgressLabel(row) }}
                            </span>
                            <div slot="content" class="order-workbench__note-tooltip-content">{{ bizProgressTooltipText(row) }}</div>
                        </el-tooltip>
                        <span v-else class="order-workbench__tax-progress-cell">{{ displayBizProgressLabel(row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="isPendingSubmitStyleTable"
                    label="注销总进度"
                    :width="resolveColumnWidth(105, false, 'total_cancel_progress')"
                >
                    <template slot-scope="{ row }">
                        <el-tooltip
                            v-if="totalCancellationProgressTooltipText(row) && !isPendingSubmitTable && !isRejectResubmitListTable && !isReviewListTable"
                            placement="top"
                            effect="dark"
                            popper-class="order-workbench__note-tooltip"
                        >
                            <span class="order-workbench__tax-progress-cell order-workbench__tax-progress-cell--hint">
                                <span class="order-workbench__total-cancel-progress-cell">{{ formatTotalCancellationProgressLabel(row) }}</span>
                            </span>
                            <div slot="content" class="order-workbench__note-tooltip-content">{{ totalCancellationProgressTooltipText(row) }}</div>
                        </el-tooltip>
                        <span v-else class="order-workbench__tax-progress-cell">
                            <span class="order-workbench__total-cancel-progress-cell">{{ formatTotalCancellationProgressLabel(row) }}</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column v-else-if="!isTaxClearedBizColumnsTable && !isArchivedListTable" label="税务进度" :width="resolveColumnWidth(76, false, 'tax_progress_status')">
                    <template slot-scope="{ row }">
                        <el-tooltip
                            v-if="taxProgressTooltipText(row) && !isPublicityTable"
                            placement="top"
                            effect="dark"
                            popper-class="order-workbench__note-tooltip"
                        >
                            <span class="order-workbench__tax-progress-cell order-workbench__tax-progress-cell--hint">
                                {{ isPublicityTable ? '已清税' : displayTaxProgressLabel(row) }}
                            </span>
                            <div slot="content" class="order-workbench__note-tooltip-content">{{ taxProgressTooltipText(row) }}</div>
                        </el-tooltip>
                        <span v-else class="order-workbench__tax-progress-cell">{{ isPublicityTable ? '已清税' : displayTaxProgressLabel(row) }}</span>
                    </template>
                </el-table-column>

                <el-table-column v-if="isPublicityTable" label="工商进度" :width="resolveColumnWidth(76, false, 'biz_progress_status')">
                    <template slot-scope="{ row }">
                        <el-tooltip
                            v-if="bizProgressTooltipText(row) && !isPublicityTable"
                            placement="top"
                            effect="dark"
                            popper-class="order-workbench__note-tooltip"
                        >
                            <span class="order-workbench__tax-progress-cell order-workbench__tax-progress-cell--hint">公示中</span>
                            <div slot="content" class="order-workbench__note-tooltip-content">{{ bizProgressTooltipText(row) }}</div>
                        </el-tooltip>
                        <span v-else class="order-workbench__tax-progress-cell">公示中</span>
                    </template>
                </el-table-column>

                <el-table-column v-if="showAnnouncementColumns" label="公示结束时间" :width="resolveColumnWidth(110, false, 'announcement_end_date')">
                    <template slot-scope="{ row }">
                        {{ formatDate(row.company && row.company.announcement_end_date) }}
                    </template>
                </el-table-column>


                <el-table-column v-if="!isArchivedListTable" label="快登" :width="resolveColumnWidth(40, false, 'quick_link')">
                    <template slot-scope="{ row }">
                        <div class="order-workbench__quick-links">
                            <el-button
                                type="text"
                                size="mini"
                                :disabled="!quickLinkUrl(row)"
                                :title="quickLinkTooltip(row)"
                                @click="quickLinkUrl(row) && openPortal(quickLinkUrl(row))"
                            >
                                {{ getQuickLinkButtonLabel(row) }}
                            </el-button>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    label="操作"
                    :width="resolveColumnWidth(190, true, 'actions')"
                    class-name="order-workbench-col--actions"
                >
                    <template slot-scope="{ row }">
                        <div class="order-workbench__row-actions-line">
                            <el-button
                                v-if="isPendingSubmitTable"
                                type="text"
                                size="mini"
                                @click="openPendingSubmitReviewDialog(row)"
                            >进度</el-button>
                            <el-button v-else-if="!isPublicityTable && !isArchivedListTable" type="text" size="mini" @click="openProgressDialog(row)">进度</el-button>
                            <el-button
                                v-if="isPublicityTable && showPublicityFlowTestAction"
                                type="text"
                                size="mini"
                                :loading="advancingPublicityTestOrderId === Number(row.id)"
                                @click="advancePublicityToPendingSubmitTest(row)"
                            >流转测</el-button>
                            <el-button type="text" size="mini" @click="openAttachmentDialog(row)">附件</el-button>
                            <el-button
                                v-if="isArchivedListTable"
                                type="text"
                                size="mini"
                                :loading="completionSmsOrderId === Number(row.id)"
                                @click="sendArchivedCompletionNoticeSms(row)"
                            >通知</el-button>
                            <el-button
                                v-if="!hideReceiptDeleteActionsForDispatchTaxOnlyTodo"
                                type="text"
                                size="mini"
                                :class="isDispatchBizOnlySpecialist ? 'order-workbench__action-link--fixed-disabled' : getReceiptLinkClass(row)"
                                :disabled="isDispatchBizOnlySpecialist"
                                @click="openReceiptDialog(row)"
                            >收款</el-button>
                            <el-button
                                v-if="!hideReceiptDeleteActionsForDispatchTaxOnlyTodo"
                                type="text"
                                size="mini"
                                :class="isDispatchBizOnlySpecialist ? 'order-workbench__action-link--fixed-disabled' : ''"
                                :disabled="isDispatchBizOnlySpecialist"
                                @click="handleDelete(row)"
                            >删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <div class="order-workbench__pager">
                <el-pagination
                    background
                    layout="total, prev, pager, next, sizes"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="orderPage"
                    :page-size="orderPerPage"
                    :total="orderListTotal"
                    @current-change="handleOrderPageChange"
                    @size-change="handleOrderPageSizeChange"
                />
            </div>
        </el-card>

        <el-dialog
            title="新增订单"
            :visible.sync="createDialogVisible"
            top="6vh"
            :close-on-click-modal="false"
            append-to-body
            destroy-on-close
            custom-class="order-workbench-hub-dialog order-workbench-hub-dialog--w-lg"
        >
            <div class="order-workbench-hub-dialog__body-inner">
                <order-create-form
                    v-if="createDialogVisible"
                    compact
                    @cancel="createDialogVisible = false"
                    @success="handleCreated"
                />
            </div>
        </el-dialog>

        <el-dialog
            title="外派"
            :visible.sync="dispatchDialogVisible"
            top="6vh"
            :close-on-click-modal="false"
            append-to-body
            custom-class="order-workbench-hub-dialog order-workbench-hub-dialog--w-sm"
        >
            <el-form ref="dispatchFormRef" class="order-workbench-hub-dialog__form" :model="dispatchForm" :rules="dispatchRules" label-width="100px">
                <el-form-item label="接收人员" prop="receiver_user_id">
                    <el-select
                        v-model="dispatchForm.receiver_user_id"
                        class="full-width"
                        filterable
                        placeholder="请选择子账号"
                        :loading="dispatchReceiversLoading"
                    >
                        <el-option
                            v-for="user in dispatchReceivers"
                            :key="user.id"
                            :label="formatDispatchReceiverLabel(user)"
                            :value="user.id"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="分派备注" prop="remark">
                    <el-input v-model.trim="dispatchForm.remark" type="textarea" :rows="4" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="order-workbench-hub-dialog__footer">
                <el-button
                    v-if="showDispatchToolbarButton"
                    type="danger"
                    plain
                    :loading="dispatchCancelling"
                    @click="cancelDispatchInDialog"
                >
                    取消外派
                </el-button>
                <el-button @click="dispatchDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="dispatchSubmitting" @click="submitDispatch">确认分派</el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="附件"
            :visible.sync="attachmentDialogVisible"
            width="560px"
            top="6vh"
            :close-on-click-modal="false"
            append-to-body
        >
            <div v-loading="attachmentLoading">
                <el-form label-width="112px">
                    <el-divider content-position="left">税务附件</el-divider>
                    <el-form-item label="清税证明">
                        <input type="file" multiple accept=".pdf,.jpg,.jpeg" @change="handleAttachmentChange('taxClearance', $event)">
                        <div v-if="attachmentNames.taxClearance.length" class="order-workbench__attachment-actions">
                            <div
                                v-for="(fileName, index) in attachmentNames.taxClearance"
                                :key="'attach-tax-clear-' + index"
                                class="order-workbench__attachment-action-row"
                            >
                                <span class="order-workbench__attachment-file-name">{{ fileName }}</span>
                                <el-button type="text" size="mini" @click="removePendingAttachmentInDialog('taxClearance', index)">删除</el-button>
                            </div>
                        </div>
                        <div v-if="attachmentExisting.taxClearance.length" class="order-workbench__attachment-actions">
                            <div v-for="file in attachmentExisting.taxClearance" :key="'attach-tax-clear-existing-' + file.id" class="order-workbench__attachment-action-row">
                                <span class="order-workbench__attachment-file-name">{{ file.file_name }}</span>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '清税证明', 'jpg')">下载JPG</el-button>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '清税证明', 'pdf')">下载PDF</el-button>
                                <el-button type="text" size="mini" @click="deleteAttachmentInDialog(file)">删除</el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="身份证正面">
                        <input type="file" multiple accept=".jpg,.jpeg,.pdf" @change="handleAttachmentChange('idCardFront', $event)">
                        <div v-if="attachmentNames.idCardFront.length" class="order-workbench__attachment-actions">
                            <div
                                v-for="(fileName, index) in attachmentNames.idCardFront"
                                :key="'attach-id-front-' + index"
                                class="order-workbench__attachment-action-row"
                            >
                                <span class="order-workbench__attachment-file-name">{{ fileName }}</span>
                                <el-button type="text" size="mini" @click="removePendingAttachmentInDialog('idCardFront', index)">删除</el-button>
                            </div>
                        </div>
                        <div v-if="attachmentExisting.idCardFront.length" class="order-workbench__attachment-actions">
                            <div v-for="file in attachmentExisting.idCardFront" :key="'attach-id-front-existing-' + file.id" class="order-workbench__attachment-action-row">
                                <span class="order-workbench__attachment-file-name">{{ file.file_name }}</span>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '身份证正面', 'jpg')">下载JPG</el-button>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '身份证正面', 'pdf')">下载PDF</el-button>
                                <el-button type="text" size="mini" @click="deleteAttachmentInDialog(file)">删除</el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="身份证背面">
                        <input type="file" multiple accept=".jpg,.jpeg,.pdf" @change="handleAttachmentChange('idCardBack', $event)">
                        <div v-if="attachmentNames.idCardBack.length" class="order-workbench__attachment-actions">
                            <div
                                v-for="(fileName, index) in attachmentNames.idCardBack"
                                :key="'attach-id-back-' + index"
                                class="order-workbench__attachment-action-row"
                            >
                                <span class="order-workbench__attachment-file-name">{{ fileName }}</span>
                                <el-button type="text" size="mini" @click="removePendingAttachmentInDialog('idCardBack', index)">删除</el-button>
                            </div>
                        </div>
                        <div v-if="attachmentExisting.idCardBack.length" class="order-workbench__attachment-actions">
                            <div v-for="file in attachmentExisting.idCardBack" :key="'attach-id-back-existing-' + file.id" class="order-workbench__attachment-action-row">
                                <span class="order-workbench__attachment-file-name">{{ file.file_name }}</span>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '身份证背面', 'jpg')">下载JPG</el-button>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '身份证背面', 'pdf')">下载PDF</el-button>
                                <el-button type="text" size="mini" @click="deleteAttachmentInDialog(file)">删除</el-button>
                            </div>
                        </div>
                    </el-form-item>

                    <el-divider content-position="left">工商附件</el-divider>
                    <el-form-item label="投资人承诺书">
                        <input type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" @change="handleAttachmentChange('bizSimpleCommitment', $event)">
                        <div v-if="attachmentNames.bizSimpleCommitment.length" class="order-workbench__attachment-actions">
                            <div v-for="(fileName, index) in attachmentNames.bizSimpleCommitment" :key="'attach-biz-simple-' + index" class="order-workbench__attachment-action-row">
                                <span class="order-workbench__attachment-file-name">{{ fileName }}</span>
                                <el-button type="text" size="mini" @click="removePendingAttachmentInDialog('bizSimpleCommitment', index)">删除</el-button>
                            </div>
                        </div>
                        <div v-if="attachmentExisting.bizSimpleCommitment.length" class="order-workbench__attachment-actions">
                            <div v-for="file in attachmentExisting.bizSimpleCommitment" :key="'attach-biz-simple-existing-' + file.id" class="order-workbench__attachment-action-row">
                                <span class="order-workbench__attachment-file-name">{{ file.file_name }}</span>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '投资人承诺书', 'jpg')">下载JPG</el-button>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '投资人承诺书', 'pdf')">下载PDF</el-button>
                                <el-button type="text" size="mini" @click="deleteAttachmentInDialog(file)">删除</el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="信用修复申请书">
                        <input type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" @change="handleAttachmentChange('creditRepairApplication', $event)">
                        <div v-if="attachmentNames.creditRepairApplication.length" class="order-workbench__attachment-actions">
                            <div v-for="(fileName, index) in attachmentNames.creditRepairApplication" :key="'attach-credit-apply-' + index" class="order-workbench__attachment-action-row">
                                <span class="order-workbench__attachment-file-name">{{ fileName }}</span>
                                <el-button type="text" size="mini" @click="removePendingAttachmentInDialog('creditRepairApplication', index)">删除</el-button>
                            </div>
                        </div>
                        <div v-if="attachmentExisting.creditRepairApplication.length" class="order-workbench__attachment-actions">
                            <div v-for="file in attachmentExisting.creditRepairApplication" :key="'attach-credit-apply-existing-' + file.id" class="order-workbench__attachment-action-row">
                                <span class="order-workbench__attachment-file-name">{{ file.file_name }}</span>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '信用修复申请书', 'jpg')">下载JPG</el-button>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '信用修复申请书', 'pdf')">下载PDF</el-button>
                                <el-button type="text" size="mini" @click="deleteAttachmentInDialog(file)">删除</el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="信用修复承诺书">
                        <input type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" @change="handleAttachmentChange('creditRepairCommitment', $event)">
                        <div v-if="attachmentNames.creditRepairCommitment.length" class="order-workbench__attachment-actions">
                            <div v-for="(fileName, index) in attachmentNames.creditRepairCommitment" :key="'attach-credit-commit-' + index" class="order-workbench__attachment-action-row">
                                <span class="order-workbench__attachment-file-name">{{ fileName }}</span>
                                <el-button type="text" size="mini" @click="removePendingAttachmentInDialog('creditRepairCommitment', index)">删除</el-button>
                            </div>
                        </div>
                        <div v-if="attachmentExisting.creditRepairCommitment.length" class="order-workbench__attachment-actions">
                            <div v-for="file in attachmentExisting.creditRepairCommitment" :key="'attach-credit-commit-existing-' + file.id" class="order-workbench__attachment-action-row">
                                <span class="order-workbench__attachment-file-name">{{ file.file_name }}</span>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '信用修复承诺书', 'jpg')">下载JPG</el-button>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '信用修复承诺书', 'pdf')">下载PDF</el-button>
                                <el-button type="text" size="mini" @click="deleteAttachmentInDialog(file)">删除</el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="执照遗失公告">
                        <input type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" @change="handleAttachmentChange('licenseLossNotice', $event)">
                        <div v-if="attachmentNames.licenseLossNotice.length" class="order-workbench__attachment-actions">
                            <div v-for="(fileName, index) in attachmentNames.licenseLossNotice" :key="'attach-license-loss-' + index" class="order-workbench__attachment-action-row">
                                <span class="order-workbench__attachment-file-name">{{ fileName }}</span>
                                <el-button type="text" size="mini" @click="removePendingAttachmentInDialog('licenseLossNotice', index)">删除</el-button>
                            </div>
                        </div>
                        <div v-if="attachmentExisting.licenseLossNotice.length" class="order-workbench__attachment-actions">
                            <div v-for="file in attachmentExisting.licenseLossNotice" :key="'attach-license-loss-existing-' + file.id" class="order-workbench__attachment-action-row">
                                <span class="order-workbench__attachment-file-name">{{ file.file_name }}</span>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '执照遗失公告', 'jpg')">下载JPG</el-button>
                                <el-button type="text" size="mini" @click="downloadAttachmentWithCompany(file, '执照遗失公告', 'pdf')">下载PDF</el-button>
                                <el-button type="text" size="mini" @click="deleteAttachmentInDialog(file)">删除</el-button>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer">
                <el-button @click="attachmentDialogVisible = false">关闭</el-button>
                <el-button type="primary" :loading="attachmentSubmitting" @click="submitAttachmentDialog">确定</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="外勤订单"
            :visible.sync="workDialogVisible"
            top="6vh"
            :close-on-click-modal="false"
            append-to-body
            custom-class="order-workbench-hub-dialog order-workbench-hub-dialog--w-field"
        >
            <div v-loading="workLoading">
                <el-form class="order-workbench-hub-dialog__form" label-width="100px">
                    <el-form-item label="合作外勤">
                        <el-select
                            v-model="workForm.field_partner_id"
                            filterable
                            clearable
                            :filter-method="onFieldPartnerFilter"
                            placeholder="请输入城市中文或拼音首字母（如：浙江 / zj）"
                            class="full-width"
                        >
                            <el-option
                                v-for="p in filteredFieldPartners"
                                :key="p.id"
                                :label="fieldPartnerOptionLabel(p)"
                                :value="Number(p.id)"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input
                            v-model.trim="workForm.remark"
                            type="textarea"
                            :rows="3"
                            maxlength="2000"
                            show-word-limit
                            placeholder="可分行输入备注"
                        />
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="order-workbench-hub-dialog__footer">
                <el-button type="danger" plain :loading="workCancelling" @click="cancelWorkInDialog">取消外勤</el-button>
                <el-button @click="workDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="workSubmitting" @click="submitWorkDialog">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="进度情况"
            :visible.sync="progressDialogVisible"
            width="560px"
            :close-on-click-modal="false"
            append-to-body
            @closed="onProgressDialogClosed"
        >
            <el-form ref="progressFormRef" :model="progressForm" :rules="progressRules" label-width="98px">
                <div v-if="isReviewListTable && progressDialogSourceRow" class="order-workbench__review-progress-banner">
                    <p class="order-workbench__review-progress-banner-line">
                        外部登记查询结果：<strong>{{ progressDialogSourceRow.external_reg_status || '暂无' }}</strong>
                        <span v-if="progressDialogSourceRow.external_reg_checked_at" class="order-workbench__review-progress-banner-meta">
                            （最近查询 {{ formatReviewCheckedAt(progressDialogSourceRow.external_reg_checked_at) }}）
                        </span>
                    </p>
                    <p class="order-workbench__review-progress-banner-tip">
                        系统每日自动查询第三方接口；登记状态为「注销」时将自动归档到「已完成」。超过7天未出现「注销」时，列表行将红色闪烁提示人工核查。
                    </p>
                </div>
                <div v-if="isReviewListTable" class="order-workbench__pending-review order-workbench__pending-review--in-progress-dialog">
                    <div class="order-workbench__pending-review-title">进度项标记（可多选）</div>
                    <el-checkbox-group v-model="reviewProgressSignSelections">
                        <div class="order-workbench__pending-review-item">
                            <el-checkbox label="pending_sign">待签字</el-checkbox>
                        </div>
                        <div class="order-workbench__pending-review-item">
                            <el-checkbox label="signed">已签字</el-checkbox>
                        </div>
                        <div class="order-workbench__pending-review-item">
                            <el-checkbox label="verified">已核名</el-checkbox>
                        </div>
                    </el-checkbox-group>
                </div>
                <template v-if="progressDialogBizMode && !isReviewListTable && !isRejectResubmitListTable">
                    <el-form-item label="工商情况" prop="biz_announcement_status">
                        <el-select v-model="progressForm.biz_announcement_status" placeholder="请选择" class="full-width">
                            <el-option label="正常" :value="1" />
                            <el-option label="吊销" :value="3" />
                            <el-option label="撤销" :value="2" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="年报情况" prop="annual_report_stage">
                        <el-select v-model="progressForm.annual_report_stage" placeholder="请选择" class="full-width">
                            <el-option label="正常" :value="1" />
                            <el-option label="逾期" :value="2" />
                            <el-option label="已补报" :value="3" />
                            <el-option label="已解异" :value="4" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="执照情况" prop="biz_license_status">
                        <el-select v-model="progressForm.biz_license_status" placeholder="请选择" class="full-width">
                            <el-option label="待公告" :value="3" />
                            <el-option label="已公告" :value="1" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="工商进度" prop="biz_progress_status">
                        <el-select v-model="progressForm.biz_progress_status" placeholder="请选择" class="full-width" @change="handleBizProgressStatusChange">
                            <el-option label="办理中" :value="101" />
                            <el-option label="公示中" :value="102" />
                            <el-option label="待提交" :value="103" />
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        v-if="Number(progressForm.biz_progress_status) === 102"
                        label="公示结束时间"
                        prop="announcement_end_date"
                    >
                        <el-date-picker
                            v-model="progressForm.announcement_end_date"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择公示结束时间"
                            class="full-width"
                        />
                    </el-form-item>
                    <el-form-item label="工商进度备注">
                        <el-input
                            v-model="progressForm.biz_note"
                            type="textarea"
                            :rows="3"
                            maxlength="2000"
                            show-word-limit
                            placeholder="请输入工商进度备注"
                        />
                    </el-form-item>
                </template>
                <template v-else-if="progressDialogBizMode && isRejectResubmitListTable">
                    <div class="order-workbench__pending-review order-workbench__pending-review--in-progress-dialog">
                        <div class="order-workbench__pending-review-title">请选择需要提交审核的进度项（可多选）</div>
                        <el-checkbox-group v-model="rejectResubmitSignSelections">
                            <div class="order-workbench__pending-review-item">
                                <el-checkbox label="pending_sign">待签字</el-checkbox>
                            </div>
                            <div class="order-workbench__pending-review-item">
                                <el-checkbox label="signed">已签字</el-checkbox>
                            </div>
                            <div class="order-workbench__pending-review-item">
                                <el-checkbox label="verified">已核名</el-checkbox>
                            </div>
                        </el-checkbox-group>
                    </div>
                    <el-form-item label="驳回原因" prop="reject_resubmit_reason">
                        <el-input
                            v-model="progressForm.reject_resubmit_reason"
                            type="textarea"
                            :rows="3"
                            maxlength="2000"
                            show-word-limit
                            placeholder="请填写驳回原因（选填）"
                        />
                    </el-form-item>
                </template>
                <template v-else-if="!progressDialogBizMode">
                    <el-form-item label="税务情况" prop="tax_account_status">
                        <el-select v-model="progressForm.tax_account_status" placeholder="请选择" class="full-width">
                            <el-option label="正常户" :value="1" />
                            <el-option label="非正常户" :value="2" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="税登方式" prop="tax_login_mode">
                        <el-select v-model="progressForm.tax_login_mode" placeholder="请选择" class="full-width">
                            <el-option label="法人扫码" :value="'法人扫码'" />
                            <el-option label="授权税员" :value="'授权税员'" />
                            <el-option label="密码登录" :value="'密码登录'" />
                            <el-option label="自行清税" :value="'自行清税'" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="税务进度" prop="tax_progress_status">
                        <el-select v-model="progressForm.tax_progress_status" placeholder="请选择" class="full-width">
                            <el-option label="清税中" :value="3" />
                            <el-option label="已清税" :value="4" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="进度备注">
                        <el-input
                            v-model="progressForm.tax_note"
                            type="textarea"
                            :rows="3"
                            maxlength="2000"
                            show-word-limit
                            placeholder="请输入进度备注"
                        />
                    </el-form-item>
                </template>
            </el-form>
            <span slot="footer">
                <template v-if="isReviewListTable">
                    <el-button
                        type="primary"
                        plain
                        :loading="reviewSignStatusSaving"
                        @click="saveReviewProgressSignSelections"
                    >保存勾选</el-button>
                    <el-button
                        type="danger"
                        plain
                        :loading="reviewRejectSubmitting"
                        @click="submitReviewMarkRejected"
                    >已驳回</el-button>
                    <el-button
                        type="warning"
                        plain
                        :loading="reviewResetSubmitting"
                        @click="submitReviewMarkStillReviewing"
                    >审核中</el-button>
                    <el-button
                        type="success"
                        plain
                        :loading="reviewDeregisterSubmitting"
                        @click="submitReviewMarkDeregistered"
                    >已注销</el-button>
                    <span class="order-workbench__review-progress-footer-gap" />
                </template>
                <template v-if="isRejectResubmitListTable">
                    <el-button
                        type="primary"
                        plain
                        :loading="rejectResubmitReopenSubmitting"
                        @click="submitRejectResubmitReopenReview"
                    >驳回再审</el-button>
                    <span class="order-workbench__review-progress-footer-gap" />
                </template>
                <el-button @click="progressDialogVisible = false">取消</el-button>
                <el-button
                    v-if="!isReviewListTable"
                    type="primary"
                    :loading="progressSubmitting"
                    @click="submitProgressDialog"
                >保存</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="提交审核"
            :visible.sync="pendingSubmitReviewDialogVisible"
            width="520px"
            :close-on-click-modal="false"
            append-to-body
        >
            <div class="order-workbench__pending-review">
                <div class="order-workbench__pending-review-title">请选择需要提交审核的进度项（可多选）</div>
                <el-checkbox-group v-model="pendingSubmitReviewSelections">
                    <div class="order-workbench__pending-review-item">
                        <el-checkbox label="pending_sign">待签字</el-checkbox>
                    </div>
                    <div class="order-workbench__pending-review-item">
                        <el-checkbox label="signed">已签字</el-checkbox>
                    </div>
                    <div class="order-workbench__pending-review-item">
                        <el-checkbox label="verified">已核名</el-checkbox>
                    </div>
                </el-checkbox-group>
            </div>
            <span slot="footer">
                <el-button @click="pendingSubmitReviewDialogVisible = false">取消</el-button>
                <el-button
                    :disabled="pendingSubmitReviewSubmitting"
                    :loading="pendingSubmitReviewSaving"
                    @click="savePendingSubmitReviewDialog"
                >保存</el-button>
                <el-button
                    type="primary"
                    :disabled="pendingSubmitReviewSaving"
                    :loading="pendingSubmitReviewSubmitting"
                    @click="submitPendingSubmitReviewDialog"
                >提交审核</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="收款"
            custom-class="order-workbench__receipt-dialog"
            :visible.sync="receiptDialogVisible"
            width="560px"
            :close-on-click-modal="false"
            append-to-body
        >
            <el-form ref="receiptFormRef" :model="receiptForm" :rules="receiptRules" label-width="98px">
                <el-form-item label="应收" prop="receivable_total">
                    <el-input-number
                        v-model="receiptForm.receivable_total"
                        :min="0"
                        :precision="2"
                        :controls="false"
                        class="full-width"
                        @focus="handleReceiptAmountFocus('receivable_total')"
                    />
                </el-form-item>
                <el-form-item label="已收" prop="paid_total">
                    <el-input-number
                        v-model="receiptForm.paid_total"
                        :min="0"
                        :precision="2"
                        :controls="false"
                        class="full-width"
                        @focus="handleReceiptAmountFocus('paid_total')"
                    />
                </el-form-item>
                <el-form-item label="待收" class="order-workbench__receipt-pending-item">
                    <el-input :value="formatAmount(receiptPendingAmount)" readonly class="order-workbench__receipt-pending-input full-width" />
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="receiptDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="receiptSubmitting" @click="submitReceiptDialog">保存</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="基础信息"
            :visible.sync="editDialogVisible"
            top="6vh"
            :close-on-click-modal="false"
            append-to-body
            custom-class="order-workbench-hub-dialog order-workbench-hub-dialog--w-md"
        >
            <div v-loading="editLoading" class="order-workbench-hub-dialog__body-inner">
                <order-create-form
                    v-if="editDialogVisible"
                    compact
                    mode="edit"
                    :order-id="currentOrderId"
                    :initial-form="editCreateInitialForm"
                    submit-text="保存"
                    @cancel="editDialogVisible = false"
                    @success="handleEditSaved"
                />
            </div>
        </el-dialog>

    </div>
</template>

<script>
import CopyableField from './CopyableField.vue';
import OrderCreateForm from './OrderCreateForm.vue';

export default {
    name: 'OrderWorkbench',
    components: {
        CopyableField: CopyableField,
        OrderCreateForm: OrderCreateForm
    },
    props: {
        title: {
            type: String,
            default: '订单列表'
        },
        showCreateButton: {
            type: Boolean,
            default: true
        },
        showTitle: {
            type: Boolean,
            default: true
        },
        hidePrimaryActions: {
            type: Boolean,
            default: false
        },
        extraQueryParams: {
            type: Object,
            default: function () {
                return {};
            }
        },
        showAnnouncementColumns: {
            type: Boolean,
            default: false
        },
        /** default | tax_cleared — 仅已清税列表使用工商类列，不影响待办件等 */
        listTableVariant: {
            type: String,
            default: 'default'
        },
        autoColumnWidth: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            createDialogVisible: false,
            dispatchDialogVisible: false,
            attachmentDialogVisible: false,
            workDialogVisible: false,
            receiptDialogVisible: false,
            progressDialogVisible: false,
            editDialogVisible: false,
            editLoading: false,
            editSubmitting: false,
            editCreateInitialForm: null,
            dispatchSubmitting: false,
            dispatchCancelling: false,
            attachmentSubmitting: false,
            workSubmitting: false,
            workCancelling: false,
            receiptSubmitting: false,
            progressSubmitting: false,
            progressDialogSourceRow: null,
            reviewRejectSubmitting: false,
            reviewResetSubmitting: false,
            reviewDeregisterSubmitting: false,
            reviewSignStatusSaving: false,
            reviewProgressSignSelections: [],
            archivedBasicExporting: false,
            completionSmsOrderId: null,
            rejectResubmitReopenSubmitting: false,
            pendingSubmitReviewDialogVisible: false,
            pendingSubmitReviewSaving: false,
            pendingSubmitReviewSubmitting: false,
            pendingSubmitReviewOrderId: null,
            pendingSubmitReviewRowSnapshot: null,
            pendingSubmitReviewSelections: [],
            rejectResubmitSignSelections: [],
            progressDialogBizMode: false,
            selectedOrderRow: null,
            rowClickSelectTimer: null,
            suppressRowSelectUntilMs: 0,
            dispatchReceiversLoading: false,
            attachmentLoading: false,
            workLoading: false,
            currentOrderId: null,
            progressOrderId: null,
            advancingPublicityTestOrderId: null,
            /** 公示中「流转测」；临时隐藏列宽调试时改为 false */
            showPublicityFlowTestAction: true,
            currentOrderTaxAccountStatus: 1,
            editTaxPortalUrl: '',
            attachmentOrderId: null,
            attachmentCompanyName: '',
            workOrderId: null,
            receiptOrderId: null,
            dispatchReceivers: [],
            attachmentAttachments: {
                taxClearance: [],
                idCardFront: [],
                idCardBack: [],
                bizSimpleCommitment: [],
                creditRepairApplication: [],
                creditRepairCommitment: [],
                licenseLossNotice: []
            },
            attachmentExisting: {
                taxClearance: [],
                idCardFront: [],
                idCardBack: [],
                bizSimpleCommitment: [],
                creditRepairApplication: [],
                creditRepairCommitment: [],
                licenseLossNotice: []
            },
            dispatchForm: {
                order_id: null,
                receiver_user_id: null,
                remark: ''
            },
            progressForm: {
                tax_account_status: null,
                tax_login_mode: null,
                tax_progress_status: null,
                tax_note: '',
                tax_portal_url: '',
                biz_announcement_status: null,
                annual_report_stage: null,
                biz_license_status: null,
                biz_progress_status: null,
                biz_authorization_status: 0,
                biz_note: '',
                biz_portal_url: '',
                announcement_end_date: '',
                reject_resubmit_reason: ''
            },
            editForm: {
                company: {
                    name: '',
                    credit_code: '',
                    legal_name: '',
                    legal_id_no: '',
                    phone: ''
                },
                order: {
                    is_work_enabled: 0,
                    tax_account_status: 1
                },
                tax: {
                    tax_login_mode: '法人扫码',
                    tax_progress_status: 1,
                    tax_note: ''
                },
                financial: {
                    work_fee: 0,
                    receivable_total: 0,
                    paid_total: 0,
                    payment_type: 1,
                    is_expense_settled: 0,
                    settlement_status: 0,
                    receivable_initialized_at: '',
                    remark: ''
                },
                work: {
                    receiver_user_id: null,
                    work_progress_status: 1,
                    offline_in_progress_flag: 0,
                    is_completed: 0,
                    work_content: '',
                    attachment_group_token: ''
                }
            },
            editRules: {
                'company.name': [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
                'company.credit_code': [{ required: true, message: '请输入统一信用代码', trigger: 'blur' }],
                'company.legal_name': [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                'company.legal_id_no': [{ required: true, message: '请输入法人身份证', trigger: 'blur' }],
                'company.phone': [{ required: true, message: '请输入法人手机号', trigger: 'blur' }],
            },
            dispatchRules: {
                receiver_user_id: [{ required: true, message: '请选择接收人员', trigger: 'change' }]
            },
            baseProgressRules: {
                tax_account_status: [{ required: true, message: '请选择税务情况', trigger: 'change' }],
                tax_login_mode: [{ required: true, message: '请选择税登方式', trigger: 'change' }],
                tax_progress_status: [{ required: true, message: '请选择税务进度', trigger: 'change' }],
                biz_announcement_status: [{ required: true, message: '请选择工商情况', trigger: 'change' }],
                annual_report_stage: [{ required: true, message: '请选择年报情况', trigger: 'change' }],
                biz_license_status: [{ required: true, message: '请选择执照情况', trigger: 'change' }],
                biz_progress_status: [{ required: true, message: '请选择工商进度', trigger: 'change' }],
            },
            receiptRules: {
                receivable_total: [{ required: true, type: 'number', min: 0, message: '请输入应收', trigger: 'change' }],
                paid_total: [{ required: true, type: 'number', min: 0, message: '请输入已收', trigger: 'change' }]
            },
            workForm: {
                is_work_enabled: 0,
                field_partner_id: null,
                remark: ''
            },
            fieldPartnerKeyword: '',
            fieldPartners: [],
            receiptForm: {
                receivable_total: 0,
                paid_total: 0,
                payment_type: 1,
                is_expense_settled: 0,
                settlement_status: 0,
                receivable_initialized_at: null,
                remark: ''
            },
            orders: [],
            orderPage: 1,
            orderPerPage: 10,
            systemEntryLinks: {
                nationalTax: '',
                qcc: '',
                publicity: '',
                bjzs: ''
            },
            dateColumnWidth: 102,
            filters: {
                keyword: '',
                publicity_end_date: ''
            }
        };
    },
    created() {
        this.fetchSystemEntryLinks();
        this.fetchFieldPartners();
        this.fetchOrders();
    },
    computed: {
        orderListTotal() {
            return (this.orders || []).length;
        },
        displayedOrders() {
            var list = this.orders || [];
            var per = this.orderPerPage || 10;
            var page = this.orderPage || 1;
            var start = (page - 1) * per;
            return list.slice(start, start + per);
        },
        attachmentNames() {
            return {
                taxClearance: this.attachmentAttachments.taxClearance.map(function (file) { return file.name; }),
                idCardFront: this.attachmentAttachments.idCardFront.map(function (file) { return file.name; }),
                idCardBack: this.attachmentAttachments.idCardBack.map(function (file) { return file.name; }),
                bizSimpleCommitment: this.attachmentAttachments.bizSimpleCommitment.map(function (file) { return file.name; }),
                creditRepairApplication: this.attachmentAttachments.creditRepairApplication.map(function (file) { return file.name; }),
                creditRepairCommitment: this.attachmentAttachments.creditRepairCommitment.map(function (file) { return file.name; }),
                licenseLossNotice: this.attachmentAttachments.licenseLossNotice.map(function (file) { return file.name; })
            };
        },
        progressRules() {
            var rules = Object.assign({}, this.baseProgressRules || {});
            if (this.progressDialogBizMode) {
                delete rules.tax_account_status;
                delete rules.tax_login_mode;
                delete rules.tax_progress_status;
                if (this.isRejectResubmitListTable) {
                    delete rules.biz_announcement_status;
                    delete rules.annual_report_stage;
                    delete rules.biz_license_status;
                    delete rules.biz_progress_status;
                }
                return rules;
            }
            return rules;
        },
        receiptPendingAmount() {
            var receivable = Number(this.receiptForm.receivable_total || 0);
            var paid = Number(this.receiptForm.paid_total || 0);
            var pending = receivable - paid;
            return pending > 0 ? pending : 0;
        },
        editPendingAmount() {
            var receivable = Number(this.editForm.financial.receivable_total || 0);
            var paid = Number(this.editForm.financial.paid_total || 0);
            var pending = receivable - paid;
            return pending > 0 ? pending : 0;
        },
        filteredFieldPartners() {
            var list = this.fieldPartners || [];
            var keyword = (this.fieldPartnerKeyword || '').trim().toLowerCase();
            if (!keyword) {
                return list;
            }

            var _this = this;
            return list.filter(function (item) {
                var name = item && item.name ? String(item.name).toLowerCase() : '';
                var province = item && item.province ? String(item.province).toLowerCase() : '';
                var company = item && item.company_name ? String(item.company_name).toLowerCase() : '';
                var label = _this.fieldPartnerOptionLabel(item).toLowerCase();
                var initials = _this.provinceInitials(item && item.province ? String(item.province) : '');

                return name.indexOf(keyword) !== -1 ||
                    province.indexOf(keyword) !== -1 ||
                    company.indexOf(keyword) !== -1 ||
                    label.indexOf(keyword) !== -1 ||
                    initials.indexOf(keyword) !== -1;
            });
        },
        isTaxClearedTable() {
            if (this.listTableVariant === 'tax_cleared') {
                return true;
            }
            var p = this.extraQueryParams || {};
            if (Number(p.tax_cleared) === 1 || Number(p.review_list) === 1 || Number(p.reject_resubmit_list) === 1) {
                return true;
            }
            var route = this.$route;
            if (route && route.name === 'tax-cleared') {
                return true;
            }
            if (route && route.name === 'review-list') {
                return true;
            }
            if (route && route.name === 'reject-resubmit-list') {
                return true;
            }
            var path = route && route.path ? String(route.path) : '';
            return path.indexOf('tax-cleared') !== -1 || path.indexOf('/review') !== -1 || path.indexOf('reject-resubmit') !== -1;
        },
        showTodoBizColumns() {
            if (this.isTaxClearedTable) {
                return false;
            }
            var p = this.extraQueryParams || {};
            if (Number(p.todo_list) === 1) {
                return true;
            }
            var route = this.$route;
            if (route && route.name === 'todos') {
                return true;
            }
            var path = route && route.path ? String(route.path) : '';
            return path.indexOf('/todos') !== -1;
        },
        isTodoTable() {
            var p = this.extraQueryParams || {};
            if (Number(p.todo_list) === 1) {
                return true;
            }
            var route = this.$route;
            if (route && route.name === 'todos') {
                return true;
            }
            var path = route && route.path ? String(route.path) : '';
            return path.indexOf('/todos') !== -1;
        },
        /** 与侧栏其它页一致：非超级管理员为子账号 */
        isWorkbenchSubaccount() {
            var u = this.$store.getters.currentUser;
            return !!(u && !u.is_super_admin);
        },
        /** 仅工商外派专员子账号：收款/删除按钮需灰化禁用 */
        isDispatchBizOnlySpecialist() {
            if (!this.isWorkbenchSubaccount) {
                return false;
            }
            var user = this.$store.getters.currentUser || {};
            var roles = user.roles || [];
            var byRoleLoose = Array.isArray(roles) && roles.indexOf('dispatch-specialist-biz') >= 0;
            var byRole = Array.isArray(roles)
                && roles.indexOf('dispatch-specialist-biz') >= 0
                && roles.indexOf('dispatch-specialist-tax') < 0
                && roles.indexOf('dispatch-specialist-both') < 0;
            var perms = user.permissions || [];
            var byPermission = Array.isArray(perms)
                && perms.indexOf('dispatch.receive') >= 0
                && perms.indexOf('biz.edit') >= 0
                && perms.indexOf('order.edit') < 0
                && perms.indexOf('order.delete') < 0;
            var menu = user.dispatch_receiver_menu || null;
            var byMenu = !!(menu && typeof menu === 'object' && menu.biz_stages === true && menu.tax_stages === false);
            return byRole || byRoleLoose || byPermission || byMenu;
        },
        /** 仅税务外派专员子账号：税务已清税后应流转到「已完成订单（外派订单页）」 */
        isDispatchTaxOnlySpecialist() {
            if (!this.isWorkbenchSubaccount) {
                return false;
            }
            var user = this.$store.getters.currentUser || {};
            var roles = user.roles || [];
            var byRole = Array.isArray(roles)
                && roles.indexOf('dispatch-specialist-tax') >= 0
                && roles.indexOf('dispatch-specialist-biz') < 0
                && roles.indexOf('dispatch-specialist-both') < 0;
            var menu = user.dispatch_receiver_menu || null;
            var byMenu = !!(menu && typeof menu === 'object' && menu.tax_stages === true && menu.biz_stages === false);
            return byRole || byMenu;
        },
        /** 仅税务外派专员：仅在待办件页隐藏「收款 / 删除」 */
        hideReceiptDeleteActionsForDispatchTaxOnlyTodo() {
            if (!this.isWorkbenchSubaccount || !this.isTodoTable) {
                return false;
            }
            var user = this.$store.getters.currentUser || {};
            var roles = user.roles || [];
            var byRole = Array.isArray(roles)
                && roles.indexOf('dispatch-specialist-tax') >= 0
                && roles.indexOf('dispatch-specialist-biz') < 0
                && roles.indexOf('dispatch-specialist-both') < 0;
            var menu = user.dispatch_receiver_menu || null;
            var byMenu = !!(menu && typeof menu === 'object' && menu.tax_stages === true && menu.biz_stages === false);
            return byRole || byMenu;
        },
        isPublicityTable() {
            var p = this.extraQueryParams || {};
            if (Number(p.publicity_list) === 1) {
                return true;
            }
            var route = this.$route;
            if (route && route.name === 'publicity') {
                return true;
            }
            var path = route && route.path ? String(route.path) : '';
            return path.indexOf('/publicity') !== -1;
        },
        isPendingSubmitTable() {
            var p = this.extraQueryParams || {};
            if (Number(p.pending_submit_list) === 1) {
                return true;
            }
            var route = this.$route;
            if (route && route.name === 'pending-submit-list') {
                return true;
            }
            var path = route && route.path ? String(route.path) : '';
            return path.indexOf('/pending-submit') !== -1;
        },
        /** 审核中列表：表格列与「待提交」一致（税务情况 + 工商进度 + 注销总进度），其它逻辑仍按已清税工作台处理 */
        isReviewListTable() {
            var p = this.extraQueryParams || {};
            if (Number(p.review_list) === 1) {
                return true;
            }
            var route = this.$route;
            if (route && route.name === 'review-list') {
                return true;
            }
            return false;
        },
        /** 驳回单：表格列与「审核中」一致；进度弹窗等仍按已清税工商表单处理 */
        isRejectResubmitListTable() {
            var p = this.extraQueryParams || {};
            if (Number(p.reject_resubmit_list) === 1) {
                return true;
            }
            var route = this.$route;
            if (route && route.name === 'reject-resubmit-list') {
                return true;
            }
            return false;
        },
        /** 已完成（已归档）列表 */
        isArchivedListTable() {
            var p = this.extraQueryParams || {};
            if (Number(p.is_archived) === 1) {
                return true;
            }
            var route = this.$route;
            if (route && route.name === 'complete') {
                return true;
            }
            var path = route && route.path ? String(route.path) : '';
            return path.indexOf('/complete') !== -1;
        },
        isPendingSubmitStyleTable() {
            return this.isPendingSubmitTable || this.isReviewListTable || this.isRejectResubmitListTable;
        },
        /** 已清税主表「工商情况 + 年报 + 执照 + 窄工商进度」列组；不含审核中、驳回单（二者与待提交同列组） */
        isTaxClearedBizColumnsTable() {
            return this.isTaxClearedTable && !this.isReviewListTable && !this.isRejectResubmitListTable;
        },
        isTaxClearedMainPage() {
            var route = this.$route;
            if (route && route.name === 'tax-cleared') {
                return true;
            }
            var path = route && route.path ? String(route.path) : '';
            return path.indexOf('/tax-cleared') !== -1;
        },
        /** 超级管理员：待办件 + 已清税 / 公示中 / 待提交 / 审核中 / 驳回单，公司名称「派」含仅工商或税工外派接收人 */
        isSuperAdminBizPipelineDispatchPaiList() {
            return this.isTodoTable || this.isTaxClearedMainPage || this.isPublicityTable || this.isPendingSubmitTable
                || this.isReviewListTable || this.isRejectResubmitListTable;
        },
        /** 外勤：仅待办件列表；已清税页不展示外勤按钮 */
        showFieldWorkToolbarButton() {
            return !this.hidePrimaryActions && this.isTodoTable;
        },
        /** 派单 / 取消外派 / 勤派角标：待办件 + 已清税主表 */
        showDispatchToolbarButton() {
            return !this.hidePrimaryActions
                && !this.isDispatchBizOnlySpecialist
                && (this.isTodoTable || this.isTaxClearedMainPage);
        },
        showDispatchToolbarSelectionHint() {
            return this.showFieldWorkToolbarButton || this.showDispatchToolbarButton;
        },
        searchInputWidth() {
            return this.isTodoTable ? 260 : 360;
        },
        hasToolbarLeading() {
            if (this.isWorkbenchSubaccount && this.isTodoTable) {
                return false;
            }
            return (this.showCreateButton && !this.hidePrimaryActions) || this.showFieldWorkToolbarButton || this.showDispatchToolbarButton;
        },
    },
    methods: {
        resolveColumnWidth(width, keepFixed, columnKey) {
            if (this.isArchivedListTable) {
                var archivedCompanyWidth = this.isDispatchBizOnlySpecialist ? 250 : 260;
                var archivedWidthMap = {
                    date: 85,
                    company_name: archivedCompanyWidth,
                    credit_code: 170,
                    legal_name: 90,
                    legal_id_no: 150,
                    phone: 110,
                    archived_tax_progress: 120,
                    archived_biz_progress: 120,
                    actions: 180
                };
                if (columnKey && Object.prototype.hasOwnProperty.call(archivedWidthMap, columnKey)) {
                    return archivedWidthMap[columnKey];
                }
            }
            if (this.isTodoTable) {
                var todoWidthMap = {
                    date: 85,
                    company_name: this.isWorkbenchSubaccount ? 240 : 250,
                    credit_code: 160,
                    legal_name: 65,
                    legal_id_no: 150,
                    phone: 95,
                    tax_account_status: 85,
                    tax_login_mode: 85,
                    tax_progress_status: 85,
                    quick_link: 55,
                    actions: 170
                };
                if (columnKey && Object.prototype.hasOwnProperty.call(todoWidthMap, columnKey)) {
                    return todoWidthMap[columnKey];
                }
            }
            if (this.isTaxClearedBizColumnsTable) {
                var taxClearedCompanyWidth = this.isDispatchBizOnlySpecialist ? 230 : 240;
                var taxClearedWidthMap = {
                    date: 83,
                    company_name: taxClearedCompanyWidth,
                    credit_code: 160,
                    legal_name: 58,
                    legal_id_no: 150,
                    phone: 95,
                    biz_announcement_status: 73,
                    annual_report_stage: 73,
                    biz_license_status: 73,
                    biz_progress_status: 73,
                    quick_link: 50,
                    actions: 160
                };
                if (columnKey && Object.prototype.hasOwnProperty.call(taxClearedWidthMap, columnKey)) {
                    return taxClearedWidthMap[columnKey];
                }
            }
            if (this.isPublicityTable) {
                var publicityCompanyWidth = this.isDispatchBizOnlySpecialist ? 245 : 255;
                var publicityWidthMap = {
                    date: 85,
                    company_name: publicityCompanyWidth,
                    credit_code: 160,
                    legal_name: 60,
                    legal_id_no: 150,
                    phone: 95,
                    tax_progress_status: 80,
                    biz_progress_status: 80,
                    announcement_end_date: 105,
                    quick_link: 55,
                    actions: 158
                };
                if (columnKey && Object.prototype.hasOwnProperty.call(publicityWidthMap, columnKey)) {
                    return publicityWidthMap[columnKey];
                }
            }
            if (this.isReviewListTable || this.isRejectResubmitListTable) {
                var reviewCompanyWidth = this.isDispatchBizOnlySpecialist ? 240 : 250;
                var reviewWidthMap = {
                    date: 85,
                    company_name: reviewCompanyWidth,
                    credit_code: 160,
                    legal_name: 65,
                    legal_id_no: 150,
                    phone: 95,
                    tax_account_status: 78,
                    biz_progress_status: 78,
                    total_cancel_progress: 105,
                    quick_link: 55,
                    actions: 165
                };
                if (columnKey && Object.prototype.hasOwnProperty.call(reviewWidthMap, columnKey)) {
                    return reviewWidthMap[columnKey];
                }
            }
            if (this.isPendingSubmitTable) {
                var pendingSubmitCompanyWidth = this.isDispatchBizOnlySpecialist ? 240 : 250;
                var pendingSubmitOnlyWidthMap = {
                    date: 85,
                    company_name: pendingSubmitCompanyWidth,
                    credit_code: 160,
                    legal_name: 65,
                    legal_id_no: 150,
                    phone: 95,
                    tax_account_status: 78,
                    biz_progress_status: 78,
                    total_cancel_progress: 105,
                    quick_link: 55,
                    actions: 165
                };
                if (columnKey && Object.prototype.hasOwnProperty.call(pendingSubmitOnlyWidthMap, columnKey)) {
                    return pendingSubmitOnlyWidthMap[columnKey];
                }
            }
            if (keepFixed) {
                return width;
            }
            return this.autoColumnWidth ? null : width;
        },
        resolveColumnMinWidth(minWidth) {
            return this.autoColumnWidth ? minWidth : null;
        },
        fieldPartnerFromWork(row) {
            var w = row && row.work ? row.work : null;
            if (!w) {
                return null;
            }
            return w.field_partner || w.fieldPartner || null;
        },
        fieldBadgeTooltip(row) {
            if (!row || !this.hasFieldBadge(row)) {
                return '';
            }
            var w = row.work || row.current_work_log || null;
            if (!w) {
                return '外勤【未指定】在办理';
            }
            var fp = this.fieldPartnerFromWork(row);
            var partnerName = fp && fp.name ? String(fp.name).trim() : '';
            var recvName = w.receiver && w.receiver.name ? String(w.receiver.name).trim() : '';
            var recvLabel = this.formatDispatchReceiverLabel(w.receiver);
            var xxx = partnerName || recvName || (recvLabel && recvLabel !== '--' ? recvLabel : '');
            if (!xxx) {
                xxx = '未指定';
            }
            return '外勤【' + xxx + '】在办理';
        },
        hasFieldBadge(row) {
            if (!row) {
                return false;
            }
            if (!this.isTodoTable) {
                return false;
            }
            if (Number(row.is_work_enabled) === 1) {
                return true;
            }
            var w = row.work || row.current_work_log || null;
            if (!w || typeof w !== 'object') {
                return false;
            }
            return Boolean(
                w.field_partner_id ||
                w.receiver_user_id ||
                (w.work_content != null && String(w.work_content).trim() !== '')
            );
        },
        companyNameDispatchPaiVisibleForRow(row) {
            if (this.isWorkbenchSubaccount) {
                return false;
            }
            if (!this.isSuperAdminBizPipelineDispatchPaiList) {
                return this.hasDispatchBadge(row);
            }
            return this.dispatchBizOnlySuperAdminPaiMarker(row)
                || this.dispatchTaxBizSuperAdminPaiMarker(row)
                || this.hasDispatchBadge(row);
        },
        dispatchBizOnlySuperAdminPaiMarker(row) {
            var d = row && row.dispatch;
            if (!d || typeof d !== 'object' || d.recalled_at) {
                return false;
            }
            return !!d.receiver_is_dispatch_biz_only_specialist;
        },
        dispatchTaxBizSuperAdminPaiMarker(row) {
            var d = row && row.dispatch;
            if (!d || typeof d !== 'object' || d.recalled_at) {
                return false;
            }
            return !!d.receiver_is_dispatch_tax_biz_specialist;
        },
        hasDispatchBadge(row) {
            if (!row) {
                return false;
            }
            // 完成就不显示
            if (row.is_archived == 1) {
                return false;
            }
            var d = row.dispatch || row.current_dispatch_order || null;
            if (!d || typeof d !== 'object') {
                return false;
            }
            if (d.recalled_at) {
                return false;
            }

            // 已清税且是税务专员不显示
            if (row.tax_progress_status == 4 && d.dispatch_scope_label == '税务') {
                return false;
            }

            // 都完成了就不显示了
            if (row.tax_progress_status == 4 && row.biz_progress_status == 103) {
                return false;
            }

            // 已清税列表：若仅外派税务且税务已清税，说明该外派任务已完成，不再展示「派」角标。
            // if (this.isTaxClearedMainPage) {
            //     var scope = Number(d.dispatch_scope || 0);
            //     var taxProgress = Number(row.tax_progress_status || 0);
            //     if (scope === 1 && taxProgress === 4) {
            //         return false;
            //     }
            // }
            if (d.dispatch_status != null) {
                return Number(d.dispatch_status) !== 3;
            }
            return true;
        },
        dispatchBadgeTooltip(row) {
            var d = row && (row.dispatch || row.current_dispatch_order || null);
            if (!row || !d || d.recalled_at) {
                return '';
            }
            var recvName = d.receiver && d.receiver.name ? String(d.receiver.name).trim() : '';
            var recvLabel = this.formatDispatchReceiverLabel(d.receiver);
            var xxx = recvName || (recvLabel && recvLabel !== '--' ? recvLabel : '');
            if (!xxx) {
                xxx = '未指定';
            }
            return '外派给【' + xxx + '】在办理';
        },
        openCreateDialog() {
            this.createDialogVisible = true;
        },
        handleOrderRowClick(row) {
            if (Date.now() < Number(this.suppressRowSelectUntilMs || 0)) {
                return;
            }
            if (this.rowClickSelectTimer) {
                clearTimeout(this.rowClickSelectTimer);
                this.rowClickSelectTimer = null;
            }
            var _this = this;
            this.rowClickSelectTimer = setTimeout(function () {
                _this.rowClickSelectTimer = null;
                if (row && _this.selectedOrderRow && Number(row.id) === Number(_this.selectedOrderRow.id)) {
                    _this.selectedOrderRow = null;
                    if (_this.$refs.ordersTableRef && _this.$refs.ordersTableRef.setCurrentRow) {
                        _this.$refs.ordersTableRef.setCurrentRow();
                    }
                    return;
                }
                _this.selectedOrderRow = row || null;
            }, 220);
        },
        handleOrderCellDblClick(row, column, cell, event) {
            if (this.rowClickSelectTimer) {
                clearTimeout(this.rowClickSelectTimer);
                this.rowClickSelectTimer = null;
            }
            this.suppressRowSelectUntilMs = Date.now() + 260;

            // If CopyableField already handles this dblclick, skip table-level copy
            var target = event && event.target ? event.target : null;
            if (target && target.closest && target.closest('.copyable-field__text')) {
                return;
            }

            var text = this.getCellCopyText(row, column);
            if (!text) {
                return;
            }
            this.copyTextToClipboard(text);
        },
        getCellCopyText(row, column) {
            if (!row || !column) {
                return '';
            }
            var label = String(column.label || '');
            if (label === '公司名称') {
                return row.company && row.company.name ? String(row.company.name) : '';
            }
            if (label === '统一信用代码') {
                return row.company && row.company.credit_code ? String(row.company.credit_code) : '';
            }
            if (label === '姓名') {
                return row.company && row.company.legal_name ? String(row.company.legal_name) : '';
            }
            if (label === '法人身份证') {
                return row.company && row.company.legal_id_no ? String(row.company.legal_id_no) : '';
            }
            if (label === '法人手机号') {
                return row.company && row.company.phone ? String(row.company.phone) : '';
            }
            if (label === '税务情况') {
                return this.formatTaxAccountStatusLabel(row.tax_account_status);
            }
            if (label === '税登方式') {
                return row.tax_login_mode ? String(row.tax_login_mode) : '';
            }
            if (label === '税务进度') {
                if (this.isArchivedListTable) {
                    return '已清税';
                }
                return this.formatTaxProgressLabel(row.tax_progress_status);
            }
            if (label === '工商情况') {
                return this.formatBizAnnouncementLabel(row.biz_announcement_status);
            }
            if (label === '执照情况') {
                return this.formatBizLicenseLabel(row.biz_license_status);
            }
            if (label === '年报情况') {
                return this.formatAnnualReportStageLabel(row.annual_report_stage);
            }
            if (label === '工商进度') {
                if (this.isArchivedListTable) {
                    return '已注销';
                }
                return this.displayBizProgressLabel(row);
            }
            if (label === '注销总进度') {
                return this.formatTotalCancellationProgressLabel(row);
            }
            return '';
        },
        copyTextToClipboard(text) {
            var value = String(text || '');
            if (!value) {
                return;
            }
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(value).then(this.showCopySuccess).catch(this.copyByTextarea.bind(this, value));
                return;
            }
            this.copyByTextarea(value);
        },
        copyByTextarea(value) {
            var textarea = document.createElement('textarea');
            textarea.value = String(value || '');
            textarea.setAttribute('readonly', 'readonly');
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                this.showCopySuccess();
            } finally {
                document.body.removeChild(textarea);
            }
        },
        showCopySuccess() {
            this.$message.success({
                message: '已复制',
                duration: 1000
            });
        },
        getRowClassName(args) {
            var row = args && args.row ? args.row : null;
            if (!row) {
                return '';
            }
            var parts = [];
            if (this.selectedOrderRow && this.selectedOrderRow.id
                && Number(row.id) === Number(this.selectedOrderRow.id)) {
                parts.push('order-workbench__row-selected');
            }
            if (this.isReviewListTable && row.review_stale_alert) {
                parts.push('order-workbench__row--review-stale-alert');
            }
            return parts.join(' ');
        },
        onProgressDialogClosed() {
            this.progressDialogSourceRow = null;
            this.rejectResubmitSignSelections = [];
            this.reviewProgressSignSelections = [];
        },
        formatReviewCheckedAt(iso) {
            if (!iso) {
                return '';
            }
            var s = String(iso);
            if (s.length >= 16) {
                return s.slice(0, 16).replace('T', ' ');
            }
            return s;
        },
        saveReviewProgressSignSelections() {
            var _this = this;
            if (!this.progressOrderId) {
                return;
            }
            var flags = this.encodePendingSubmitSignSelections(this.reviewProgressSignSelections);
            this.reviewSignStatusSaving = true;
            window.axios
                .put('/orders/' + this.progressOrderId + '/review/submit-sign-status', {
                    submit_sign_status: flags
                })
                .then(function (response) {
                    var data = response.data && response.data.data ? response.data.data : null;
                    if (data) {
                        _this.progressDialogSourceRow = data;
                        _this.reviewProgressSignSelections = _this.decodePendingSubmitSignSelections(data.submit_sign_status);
                    }
                    _this.$message.success('进度项标记已保存');
                    _this.fetchOrders();
                })
                .catch(function (error) {
                    var message = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : '保存失败';
                    _this.$message.error(message);
                })
                .finally(function () {
                    _this.reviewSignStatusSaving = false;
                });
        },
        submitReviewMarkRejected() {
            var _this = this;
            if (!this.progressOrderId) {
                return;
            }
            this.$confirm('确认将该单标记为已驳回？订单将移入「驳回单」列表。', '已驳回', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this.reviewRejectSubmitting = true;
                return window.axios.post('/orders/' + _this.progressOrderId + '/review/mark-rejected');
            }).then(function () {
                _this.$message.success('已移入驳回单');
                _this.progressDialogVisible = false;
                _this.fetchOrders();
            }).catch(function (err) {
                if (err === 'cancel') {
                    return;
                }
                var message = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : '操作失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.reviewRejectSubmitting = false;
            });
        },
        submitRejectResubmitReopenReview() {
            var _this = this;
            if (!this.progressOrderId) {
                return;
            }
            var flags = this.encodePendingSubmitSignSelections(this.rejectResubmitSignSelections);
            if (!flags) {
                this.$message.warning('请至少选择一项提交审核的进度项');
                return;
            }
            this.$confirm('确认「驳回再审」？订单将重新进入「审核中」列表并重新起算监控。', '驳回再审', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this.rejectResubmitReopenSubmitting = true;
                return window.axios.post('/orders/' + _this.progressOrderId + '/reject-resubmit/reopen-for-review', {
                    reject_reason: _this.progressForm.reject_resubmit_reason != null
                        ? String(_this.progressForm.reject_resubmit_reason).trim()
                        : '',
                    submit_sign_status: flags
                });
            }).then(function () {
                _this.$message.success('已重新进入审核中');
                _this.progressDialogVisible = false;
                _this.fetchOrders();
            }).catch(function (err) {
                if (err === 'cancel') {
                    return;
                }
                var message = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : '操作失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.rejectResubmitReopenSubmitting = false;
            });
        },
        submitReviewMarkStillReviewing() {
            var _this = this;
            if (!this.progressOrderId) {
                return;
            }
            this.$confirm('确认仍在审核中？将重新起算7日监控并取消当前红色提醒。', '审核中', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(function () {
                _this.reviewResetSubmitting = true;
                return window.axios.post('/orders/' + _this.progressOrderId + '/review/still-reviewing');
            }).then(function () {
                _this.$message.success('已重新起算监控');
                _this.progressDialogVisible = false;
                _this.fetchOrders();
            }).catch(function (err) {
                if (err === 'cancel') {
                    return;
                }
                var message = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : '操作失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.reviewResetSubmitting = false;
            });
        },
        submitReviewMarkDeregistered() {
            var _this = this;
            if (!this.progressOrderId) {
                return;
            }
            var isDispatchBizOnly = this.isDispatchBizOnlySpecialist;
            var confirmContent = isDispatchBizOnly
                ? '确认登记状态为「已注销」？订单将进入「已完成」列表（默认未归档）；与系统自动查询结果无关，请核实后再操作。'
                : '确认登记状态为「已注销」？订单将立即归档并进入「已完成」列表；与系统自动查询结果无关，请核实后再操作。';
            var confirmButtonText = isDispatchBizOnly ? '确认注销' : '确定归档';
            this.$confirm(
                confirmContent,
                '已注销',
                {
                    confirmButtonText: confirmButtonText,
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(function () {
                _this.reviewDeregisterSubmitting = true;
                return window.axios.post('/orders/' + _this.progressOrderId + '/review/mark-deregistered');
            }).then(function (res) {
                var msg = res && res.data && res.data.message
                    ? res.data.message
                    : (isDispatchBizOnly ? '已确认注销并进入已完成列表（未归档）' : '已归档至已完成');
                _this.$message.success(msg);
                _this.progressDialogVisible = false;
                _this.fetchOrders();
            }).catch(function (err) {
                if (err === 'cancel') {
                    return;
                }
                var message = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : '操作失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.reviewDeregisterSubmitting = false;
            });
        },
        openWorkDialogFromToolbar() {
            if (!this.selectedOrderRow || !this.selectedOrderRow.id) {
                this.$message.warning('请先在列表中点击选择一条订单，再操作外勤');
                return;
            }
            this.openWorkDialog(this.selectedOrderRow);
        },
        openEditDialogFromToolbar() {
            if (!this.selectedOrderRow || !this.selectedOrderRow.id) {
                this.$message.warning('请先在列表中点击选择一条订单，再操作修改');
                return;
            }
            this.handleEditOrPublicity(this.selectedOrderRow);
        },
        openDispatchDialogFromToolbar() {
            if (!this.selectedOrderRow || !this.selectedOrderRow.id) {
                this.$message.warning('请先在列表中点击选择一条订单，再操作派单');
                return;
            }
            this.openDispatchDialog(this.selectedOrderRow);
        },
        handleEditOrPublicity(row) {
            if (this.isTaxClearedTable) {
                this.markAsPublicity(row);
                return;
            }
            this.openEditDialog(row);
        },
        markAsPublicity(row) {
            var _this = this;
            if (!row || !row.id) {
                return;
            }
            var dateText = (row.company && row.company.announcement_end_date)
                ? row.company.announcement_end_date
                : this.todayDateString();
            this.$confirm('确认将该订单流转到「公示中」吗？', '公示确认', { type: 'warning' }).then(function () {
                return window.axios.put('/orders/' + row.id + '/receipt', {
                    company: {
                        announcement_end_date: dateText
                    }
                }).then(function () {
                    return window.axios.put('/orders/' + row.id + '/biz', {
                        biz_progress_status: 102,
                        biz_authorization_status: row.biz_authorization_status != null ? Number(row.biz_authorization_status) : 0,
                        biz_license_status: row.biz_license_status != null ? Number(row.biz_license_status) : 0,
                        biz_annual_report_status: row.biz_annual_report_status != null ? Number(row.biz_annual_report_status) : 0,
                        biz_note: row.biz_note != null ? String(row.biz_note) : '',
                        biz_portal_url: row.biz_portal_url || ''
                    });
                }).then(function () {
                    _this.$message.success('已流转到公示中');
                    _this.fetchOrders();
                }).catch(function (error) {
                    var message = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : '流转公示中失败';
                    _this.$message.error(message);
                });
            }).catch(function () {
            });
        },
        todayDateString() {
            var now = new Date();
            var year = now.getFullYear();
            var month = String(now.getMonth() + 1).padStart(2, '0');
            var day = String(now.getDate()).padStart(2, '0');
            return year + '-' + month + '-' + day;
        },
        openPortal(url, targetName) {
            var target = targetName ? String(targetName) : '_blank';
            var win = window.open(url, target);
            if (win && win.focus) {
                win.focus();
            }
        },
        fetchSystemEntryLinks() {
            var _this = this;
            window.axios.get('/quick-links').then(function (response) {
                var list = response.data.data || [];
                var nationalTax = '';
                var qcc = '';
                var publicity = '';
                var bjzs = '';
                for (var i = 0; i < list.length; i += 1) {
                    var item = list[i] || {};
                    if (Number(item.link_type) === 5 && Number(item.status) === 1) {
                        nationalTax = item.url || '';
                    }
                    if (Number(item.link_type) === 3 && Number(item.status) === 1) {
                        qcc = item.url || '';
                    }
                    if (Number(item.link_type) === 4 && Number(item.status) === 1) {
                        publicity = item.url || '';
                    }
                    if (Number(item.link_type) === 6 && Number(item.status) === 1) {
                        bjzs = item.url || '';
                    }
                }
                _this.systemEntryLinks.nationalTax = nationalTax;
                _this.systemEntryLinks.qcc = qcc;
                _this.systemEntryLinks.publicity = publicity;
                _this.systemEntryLinks.bjzs = bjzs;
            }).catch(function () {
                _this.systemEntryLinks.nationalTax = '';
                _this.systemEntryLinks.qcc = '';
                _this.systemEntryLinks.publicity = '';
                _this.systemEntryLinks.bjzs = '';
            });
        },
        fetchFieldPartners() {
            var _this = this;
            window.axios.get('/field-partners', { params: { active_only: 1, specialist_only: 1 } }).then(function (response) {
                _this.fieldPartners = response.data.data || [];
            }).catch(function () {
                _this.fieldPartners = [];
            });
        },
        onFieldPartnerFilter(query) {
            this.fieldPartnerKeyword = query || '';
        },
        provinceInitials(provinceText) {
            var text = provinceText ? String(provinceText).trim() : '';
            if (!text) {
                return '';
            }

            var aliases = {
                '北京市': 'bj', '北京': 'bj',
                '天津市': 'tj', '天津': 'tj',
                '上海市': 'sh', '上海': 'sh',
                '重庆市': 'cq', '重庆': 'cq',
                '河北省': 'hb', '河北': 'hb',
                '山西省': 'sx', '山西': 'sx',
                '辽宁省': 'ln', '辽宁': 'ln',
                '吉林省': 'jl', '吉林': 'jl',
                '黑龙江省': 'hlj', '黑龙江': 'hlj',
                '江苏省': 'js', '江苏': 'js',
                '浙江省': 'zj', '浙江': 'zj',
                '安徽省': 'ah', '安徽': 'ah',
                '福建省': 'fj', '福建': 'fj',
                '江西省': 'jx', '江西': 'jx',
                '山东省': 'sd', '山东': 'sd',
                '河南省': 'hn', '河南': 'hn',
                '湖北省': 'hubei', '湖北': 'hubei',
                '湖南省': 'hunan', '湖南': 'hunan',
                '广东省': 'gd', '广东': 'gd',
                '海南省': 'hain', '海南': 'hain',
                '四川省': 'sc', '四川': 'sc',
                '贵州省': 'gz', '贵州': 'gz',
                '云南省': 'yn', '云南': 'yn',
                '陕西省': 'sn', '陕西': 'sn',
                '甘肃省': 'gs', '甘肃': 'gs',
                '青海省': 'qh', '青海': 'qh',
                '内蒙古自治区': 'nmg', '内蒙古': 'nmg',
                '广西壮族自治区': 'gx', '广西': 'gx',
                '西藏自治区': 'xz', '西藏': 'xz',
                '宁夏回族自治区': 'nx', '宁夏': 'nx',
                '新疆维吾尔自治区': 'xj', '新疆': 'xj',
                '香港特别行政区': 'xg', '香港': 'xg',
                '澳门特别行政区': 'am', '澳门': 'am',
                '台湾省': 'tw', '台湾': 'tw',
                '全国': 'qg'
            };

            return aliases[text] || '';
        },
        fieldPartnerOptionLabel(p) {
            if (!p) {
                return '';
            }
            var name = p.name ? String(p.name) : '';
            var province = p.province ? String(p.province) : '';
            if (province) {
                return name + ' · ' + province;
            }
            return name;
        },
        openSystemEntryPortal(type) {
            var url = '';
            var targetName = 'thirdparty_portal_window';
            if (type === 'nationalTax') {
                url = this.systemEntryLinks.nationalTax;
                targetName = 'thirdparty_portal_national_tax';
            } else if (type === 'qcc') {
                url = this.systemEntryLinks.qcc;
                targetName = 'thirdparty_portal_qcc';
            } else if (type === 'publicity') {
                url = this.systemEntryLinks.publicity;
                targetName = 'thirdparty_portal_publicity';
            } else {
                url = this.systemEntryLinks.bjzs;
                targetName = 'thirdparty_portal_bjzs';
            }
            if (!url || url === '#') {
                this.$message.warning('请先在设置中心配置入口链接');
                return;
            }
            this.openPortal(url, targetName);
        },
        openWorkDialog(row) {
            var _this = this;
            if (!row || !row.id) {
                return;
            }
            this.workOrderId = Number(row.id);
            this.workDialogVisible = true;
            this.workLoading = true;

            window.axios.get('/orders/' + this.workOrderId).then(function (response) {
                var data = response.data.data || {};
                var w = data.work || {};
                _this.workForm = {
                    is_work_enabled: 1,
                    field_partner_id: w.field_partner_id != null ? Number(w.field_partner_id) : null,
                    remark: w.work_content ? String(w.work_content) : ''
                };
            }).catch(function () {
                _this.$message.error('外勤信息加载失败');
            }).finally(function () {
                _this.workLoading = false;
            });
        },
        getReceiptLinkClass(row) {
            if (this.isDispatchBizOnlySpecialist) {
                return 'order-workbench__action-link--fixed-disabled';
            }
            var f = row && row.financial;
            if (!f) {
                return 'order-workbench__receipt-link--uncollected';
            }
            var r = Math.round(Number(f.receivable_total || 0) * 100) / 100;
            var p = Math.round(Number(f.paid_total || 0) * 100) / 100;
            if (r <= 0) {
                return 'order-workbench__receipt-link--neutral';
            }
            if (p >= r) {
                return 'order-workbench__receipt-link--full';
            }
            if (p <= 0) {
                return 'order-workbench__receipt-link--uncollected';
            }
            return 'order-workbench__receipt-link--partial';
        },
        openReceiptDialog(row) {
            var _this = this;
            if (this.isDispatchBizOnlySpecialist) {
                return;
            }
            if (!row || !row.id) {
                return;
            }
            this.receiptOrderId = Number(row.id);
            this.receiptDialogVisible = true;
            this.workLoading = true;
            window.axios.get('/orders/' + this.receiptOrderId).then(function (response) {
                var data = response.data.data || {};
                _this.receiptForm = {
                    receivable_total: data.financial && data.financial.receivable_total != null ? Number(data.financial.receivable_total) : 0,
                    paid_total: data.financial && data.financial.paid_total != null ? Number(data.financial.paid_total) : 0,
                    payment_type: data.financial && data.financial.payment_type != null ? Number(data.financial.payment_type) : 1,
                    is_expense_settled: data.financial && data.financial.is_expense_settled != null ? Number(data.financial.is_expense_settled) : 0,
                    settlement_status: data.expense_settlement && data.expense_settlement.settlement_status != null ? Number(data.expense_settlement.settlement_status) : 0,
                    receivable_initialized_at: data.financial && data.financial.receivable_initialized_at ? data.financial.receivable_initialized_at : null,
                    remark: data.financial && data.financial.remark ? String(data.financial.remark) : ''
                };
            }).catch(function () {
                _this.$message.error('加载收款信息失败');
            }).finally(function () {
                _this.workLoading = false;
            });
        },
        submitReceiptDialog() {
            var _this = this;
            if (!this.receiptOrderId) {
                this.$message.error('订单信息缺失');
                return;
            }
            this.$refs.receiptFormRef.validate(function (valid) {
                if (!valid) {
                    return false;
                }
                _this.receiptSubmitting = true;
                window.axios.put('/orders/' + _this.receiptOrderId + '/financial', {
                    receivable_total: Number(_this.receiptForm.receivable_total || 0),
                    paid_total: Number(_this.receiptForm.paid_total || 0),
                    payment_type: Number(_this.receiptForm.payment_type != null ? _this.receiptForm.payment_type : 1),
                    is_expense_settled: Number(_this.receiptForm.is_expense_settled != null ? _this.receiptForm.is_expense_settled : 0),
                    settlement_status: Number(_this.receiptForm.settlement_status != null ? _this.receiptForm.settlement_status : 0),
                    receivable_initialized_at: _this.receiptForm.receivable_initialized_at || null,
                    for_sale_amount: Number(_this.receiptPendingAmount || 0),
                    remark: _this.receiptForm.remark || ''
                }).then(function () {
                    _this.$message.success('收款更新成功');
                    _this.receiptDialogVisible = false;
                    _this.fetchOrders();
                }).catch(function (error) {
                    var message = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : '收款更新失败';
                    _this.$message.error(message);
                }).finally(function () {
                    _this.receiptSubmitting = false;
                });
            });
        },
        handleReceiptAmountFocus(field) {
            if (!field || !this.receiptForm) {
                return;
            }
            var value = Number(this.receiptForm[field] || 0);
            if (value === 0) {
                this.$set(this.receiptForm, field, null);
            }
        },
        submitWorkDialog() {
            var _this = this;
            if (!this.workOrderId) {
                this.$message.error('订单信息缺失');
                return;
            }

            this.workSubmitting = true;

            var payload = {
                is_work_enabled: 1,
                work_remark: _this.workForm.remark != null ? String(_this.workForm.remark) : ''
            };
            payload.field_partner_id = _this.workForm.field_partner_id != null ? Number(_this.workForm.field_partner_id) : null;

            window.axios.put('/orders/' + this.workOrderId + '/field-work', payload).then(function () {
                _this.$message.success('外勤订单更新成功');
                _this.workDialogVisible = false;
                _this.fetchOrders();
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '外勤订单更新失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.workSubmitting = false;
            });
        },
        cancelWorkInDialog() {
            var _this = this;
            if (!this.workOrderId) {
                this.$message.error('订单信息缺失');
                return;
            }
            this.$confirm('确认取消该订单外勤吗？取消后将清空合作外勤及费用。', '提示', {
                type: 'warning'
            }).then(function () {
                _this.workCancelling = true;
                return window.axios.put('/orders/' + _this.workOrderId + '/field-work', {
                    is_work_enabled: 0,
                    field_partner_id: null,
                    field_payable_total: 0,
                    field_paid_total: 0,
                    work_remark: ''
                });
            }).then(function () {
                _this.$message.success('已取消外勤');
                _this.workDialogVisible = false;
                _this.fetchOrders();
            }).catch(function (error) {
                if (error === 'cancel') {
                    return;
                }
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '取消外勤失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.workCancelling = false;
            });
        },
        openAttachmentDialog(row) {
            var _this = this;
            if (!row || !row.id) {
                return;
            }
            this.attachmentOrderId = Number(row.id);
            this.attachmentCompanyName = row.company && row.company.name ? String(row.company.name) : '';
            this.attachmentAttachments = {
                taxClearance: [],
                idCardFront: [],
                idCardBack: [],
                bizSimpleCommitment: [],
                creditRepairApplication: [],
                creditRepairCommitment: [],
                licenseLossNotice: []
            };
            this.attachmentExisting = {
                taxClearance: [],
                idCardFront: [],
                idCardBack: [],
                bizSimpleCommitment: [],
                creditRepairApplication: [],
                creditRepairCommitment: [],
                licenseLossNotice: []
            };
            this.attachmentDialogVisible = true;
            this.attachmentLoading = true;
            window.axios.get('/orders/' + this.attachmentOrderId).then(function (response) {
                var data = response.data.data || {};
                _this.attachmentExisting = _this.groupEditExistingAttachments(data.remarks || []);
            }).catch(function () {
                _this.$message.error('附件加载失败');
            }).finally(function () {
                _this.attachmentLoading = false;
            });
        },
        handleAttachmentChange(type, event) {
            var files = event && event.target && event.target.files ? Array.prototype.slice.call(event.target.files) : [];
            this.$set(this.attachmentAttachments, type, files);
        },
        removePendingAttachmentInDialog(type, index) {
            if (!this.attachmentAttachments[type] || index < 0) {
                return;
            }
            var nextFiles = this.attachmentAttachments[type].slice();
            nextFiles.splice(index, 1);
            this.$set(this.attachmentAttachments, type, nextFiles);
        },
        submitAttachmentDialog() {
            var _this = this;
            if (!this.attachmentOrderId) {
                this.$message.error('订单信息缺失');
                return;
            }

            var tasks = [];
            if (this.attachmentAttachments.taxClearance.length) {
                tasks.push(this.uploadAttachmentGroupInDialog('清税证明', this.attachmentAttachments.taxClearance));
            }
            if (this.attachmentAttachments.idCardFront.length) {
                tasks.push(this.uploadAttachmentGroupInDialog('身份证正面', this.attachmentAttachments.idCardFront));
            }
            if (this.attachmentAttachments.idCardBack.length) {
                tasks.push(this.uploadAttachmentGroupInDialog('身份证背面', this.attachmentAttachments.idCardBack));
            }
            if (this.attachmentAttachments.bizSimpleCommitment.length) {
                tasks.push(this.uploadAttachmentGroupInDialog('投资人承诺书', this.attachmentAttachments.bizSimpleCommitment));
            }
            if (this.attachmentAttachments.creditRepairApplication.length) {
                tasks.push(this.uploadAttachmentGroupInDialog('信用修复申请书', this.attachmentAttachments.creditRepairApplication));
            }
            if (this.attachmentAttachments.creditRepairCommitment.length) {
                tasks.push(this.uploadAttachmentGroupInDialog('信用修复承诺书', this.attachmentAttachments.creditRepairCommitment));
            }
            if (this.attachmentAttachments.licenseLossNotice.length) {
                tasks.push(this.uploadAttachmentGroupInDialog('执照遗失公告', this.attachmentAttachments.licenseLossNotice));
            }

            if (!tasks.length) {
                this.$message.warning('请先选择要上传的文件');
                return;
            }

            this.attachmentSubmitting = true;
            Promise.all(tasks).then(function () {
                _this.$message.success('附件上传成功');
                _this.attachmentAttachments = {
                    taxClearance: [],
                    idCardFront: [],
                    idCardBack: [],
                    bizSimpleCommitment: [],
                    creditRepairApplication: [],
                    creditRepairCommitment: [],
                    licenseLossNotice: []
                };
                return window.axios.get('/orders/' + _this.attachmentOrderId);
            }).then(function (response) {
                var data = response.data.data || {};
                _this.attachmentExisting = _this.groupEditExistingAttachments(data.remarks || []);
                _this.fetchOrders();
                _this.attachmentDialogVisible = false;
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '附件上传失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.attachmentSubmitting = false;
            });
        },
        uploadAttachmentGroupInDialog(remarkType, files) {
            var formData = new window.FormData();
            formData.append('remark_type', remarkType);
            formData.append('related_process_node', 'tax');
            formData.append('remark_content', remarkType);
            files.forEach(function (file) {
                formData.append('attachments[]', file);
            });
            return window.axios.post('/orders/' + this.attachmentOrderId + '/remarks', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        },
        deleteAttachmentInDialog(file) {
            var _this = this;
            if (!this.attachmentOrderId || !file || !file.id) {
                return;
            }
            this.$confirm('确认删除该附件吗？', '删除附件', { type: 'warning' }).then(function () {
                return window.axios.delete('/orders/' + _this.attachmentOrderId + '/remarks/attachments/' + file.id).then(function () {
                    _this.$message.success('附件删除成功');
                    return window.axios.get('/orders/' + _this.attachmentOrderId);
                }).then(function (response) {
                    var data = response.data.data || {};
                    _this.attachmentExisting = _this.groupEditExistingAttachments(data.remarks || []);
                    _this.fetchOrders();
                }).catch(function (error) {
                    var message = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : '附件删除失败';
                    _this.$message.error(message);
                });
            }).catch(function () {
            });
        },
        downloadAttachmentWithCompany(file, label, targetFormat) {
            var companyName = this.attachmentCompanyName || (this.editForm && this.editForm.company && this.editForm.company.name ? this.editForm.company.name : '公司');
            return this.downloadAttachmentAs(file, label, targetFormat, companyName, this.attachmentOrderId);
        },
        openProgressDialog(row) {
            if (!row || !row.id) {
                return;
            }
            this.progressDialogBizMode = !!this.isTaxClearedTable;
            this.progressOrderId = Number(row.id);
            this.currentOrderTaxAccountStatus = row.tax_account_status != null ? Number(row.tax_account_status) : 0;
            var bizAnnouncementStatus = row.biz_announcement_status != null ? Number(row.biz_announcement_status) : 0;
            var annualReportStage = row.annual_report_stage != null ? Number(row.annual_report_stage) : 0;
            var bizLicenseStatus = row.biz_license_status != null ? Number(row.biz_license_status) : 0;
            var bizProgressStatus = row.biz_progress_status != null ? Number(row.biz_progress_status) : 0;
            var bizUninitialized = (bizAnnouncementStatus === 0) && (annualReportStage === 0) && (bizLicenseStatus === 9) && (bizProgressStatus === 101);
            this.progressForm = {
                tax_account_status: row.tax_account_status != null && Number(row.tax_account_status) !== 0
                    ? Number(row.tax_account_status)
                    : null,
                tax_login_mode: (function () {
                    var m = row.tax_login_mode;
                    if (m == null || m === '' || m === '0') {
                        return null;
                    }
                    var s = String(m);
                    if (s === '法人扫脸') {
                        return '法人扫码';
                    }
                    if (s === '办税员') {
                        return '授权税员';
                    }
                    var allowedLogin = ['法人扫码', '授权税员', '密码登录', '自行清税'];
                    if (allowedLogin.indexOf(s) !== -1) {
                        return s;
                    }
                    return null;
                })(),
                tax_progress_status: (function () {
                    var v = row.tax_progress_status != null ? Number(row.tax_progress_status) : 0;
                    if (v === 2) {
                        v = 1;
                    }
                    var allowed = [3, 4];
                    return allowed.indexOf(v) !== -1 ? v : null;
                })(),
                tax_note: row.tax_note != null ? String(row.tax_note) : '',
                tax_portal_url: row.tax_portal_url || '',
                biz_announcement_status: (bizAnnouncementStatus > 0 && !bizUninitialized) ? bizAnnouncementStatus : null,
                annual_report_stage: (annualReportStage > 0 && !bizUninitialized) ? annualReportStage : null,
                biz_license_status: (bizLicenseStatus > 0 && bizLicenseStatus !== 9 && !bizUninitialized) ? bizLicenseStatus : null,
                biz_progress_status: (bizProgressStatus > 0 && !bizUninitialized) ? bizProgressStatus : null,
                biz_authorization_status: row.biz_authorization_status != null ? Number(row.biz_authorization_status) : 0,
                biz_note: row.biz_note != null ? String(row.biz_note) : '',
                biz_portal_url: row.biz_portal_url || '',
                announcement_end_date: row.company && row.company.announcement_end_date
                    ? String(row.company.announcement_end_date).slice(0, 10)
                    : '',
                reject_resubmit_reason: row.review_resubmit_reason != null ? String(row.review_resubmit_reason) : ''
            };
            this.progressDialogSourceRow = row;
            if (this.isRejectResubmitListTable) {
                this.rejectResubmitSignSelections = this.decodePendingSubmitSignSelections(row.submit_sign_status);
            } else {
                this.rejectResubmitSignSelections = [];
            }
            if (this.isReviewListTable) {
                this.reviewProgressSignSelections = this.decodePendingSubmitSignSelections(row.submit_sign_status);
            } else {
                this.reviewProgressSignSelections = [];
            }
            this.progressDialogVisible = true;
            this.$nextTick(function () {
                if (this.$refs.progressFormRef) {
                    this.$refs.progressFormRef.clearValidate();
                }
            });
        },
        submitProgressDialog() {
            var _this = this;
            if (!this.progressOrderId) {
                this.$message.error('订单信息缺失');
                return;
            }
            this.$refs.progressFormRef.validate(function (valid) {
                if (!valid) {
                    return false;
                }
                _this.progressSubmitting = true;
                if (_this.progressDialogBizMode) {
                    if (Number(_this.progressForm.biz_progress_status) === 102 && !_this.progressForm.announcement_end_date) {
                        _this.progressSubmitting = false;
                        _this.$message.warning('工商进度为“公示中”时，请选择公示结束时间');
                        return;
                    }

                    var receiptPayload = {
                        order: {
                            biz_announcement_status: Number(_this.progressForm.biz_announcement_status || 1),
                            annual_report_stage: Number(_this.progressForm.annual_report_stage || 2)
                        }
                    };

                    if (Number(_this.progressForm.biz_progress_status) === 102) {
                        receiptPayload.company = {
                            announcement_end_date: _this.progressForm.announcement_end_date
                        };
                    }

                    window.axios.put('/orders/' + _this.progressOrderId + '/receipt', receiptPayload).then(function () {
                        return window.axios.put('/orders/' + _this.progressOrderId + '/biz', {
                            biz_progress_status: Number(_this.progressForm.biz_progress_status || 101),
                            biz_authorization_status: Number(_this.progressForm.biz_authorization_status || 0),
                            biz_license_status: Number(_this.progressForm.biz_license_status || 1),
                            biz_annual_report_status: _this.mapAnnualReportStageToBizAnnualStatus(_this.progressForm.annual_report_stage),
                            biz_note: _this.progressForm.biz_note != null ? String(_this.progressForm.biz_note) : '',
                            biz_portal_url: _this.progressForm.biz_portal_url || ''
                        });
                    }).then(function () {
                        _this.$message.success('进度更新成功');
                        _this.progressDialogVisible = false;
                        _this.fetchOrders();
                    }).catch(function (error) {
                        var message = error && error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : '进度更新失败';
                        _this.$message.error(message);
                    }).finally(function () {
                        _this.progressSubmitting = false;
                    });
                    return;
                }

                if (
                    Number(_this.progressForm.tax_account_status || 0) === 0 ||
                    String(_this.progressForm.tax_login_mode || '0') === '0' ||
                    Number(_this.progressForm.tax_progress_status || 0) === 0
                ) {
                    _this.progressSubmitting = false;
                    _this.$message.warning('请先完善税务情况、税登方式和税务进度');
                    return false;
                }

                window.axios.put('/orders/' + _this.progressOrderId + '/tax', {
                    tax_account_status: Number(_this.progressForm.tax_account_status || 1),
                    tax_login_mode: _this.progressForm.tax_login_mode || '法人扫码',
                    tax_progress_status: Number(_this.progressForm.tax_progress_status || 1),
                    tax_note: _this.progressForm.tax_note != null ? String(_this.progressForm.tax_note) : '',
                    tax_portal_url: _this.progressForm.tax_portal_url || ''
                }).then(function () {
                    _this.$message.success('进度更新成功');
                    _this.progressDialogVisible = false;
                    _this.fetchOrders();
                }).catch(function (error) {
                    var message = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : '进度更新失败';
                    _this.$message.error(message);
                }).finally(function () {
                    _this.progressSubmitting = false;
                });
            });
        },
        encodePendingSubmitSignSelections(selections) {
            var flags = 0;
            var list = selections || [];
            if (list.indexOf('pending_sign') !== -1) {
                flags |= 1;
            }
            if (list.indexOf('signed') !== -1) {
                flags |= 2;
            }
            if (list.indexOf('verified') !== -1) {
                flags |= 4;
            }
            return flags;
        },
        decodePendingSubmitSignSelections(flags) {
            var n = Number(flags || 0);
            var out = [];
            if ((n & 1) === 1) {
                out.push('pending_sign');
            }
            if ((n & 2) === 2) {
                out.push('signed');
            }
            if ((n & 4) === 4) {
                out.push('verified');
            }
            return out;
        },
        openPendingSubmitReviewDialog(row) {
            if (!row || !row.id || !this.isPendingSubmitTable) {
                return;
            }
            this.pendingSubmitReviewOrderId = Number(row.id);
            this.pendingSubmitReviewRowSnapshot = row;
            this.pendingSubmitReviewSelections = this.decodePendingSubmitSignSelections(row.submit_sign_status);
            this.pendingSubmitReviewDialogVisible = true;
        },
        savePendingSubmitReviewDialog() {
            var _this = this;
            if (!this.pendingSubmitReviewOrderId) {
                this.$message.error('订单信息缺失');
                return;
            }
            var flags = this.encodePendingSubmitSignSelections(this.pendingSubmitReviewSelections);
            if (!flags) {
                this.$message.warning('请至少选择一项');
                return;
            }

            this.pendingSubmitReviewSaving = true;
            window.axios.put('/orders/' + this.pendingSubmitReviewOrderId + '/pending-submit-review-draft', {
                submit_sign_status: flags
            }).then(function (response) {
                var data = response.data && response.data.data ? response.data.data : null;
                if (data) {
                    _this.pendingSubmitReviewRowSnapshot = data;
                    _this.pendingSubmitReviewSelections = _this.decodePendingSubmitSignSelections(data.submit_sign_status);
                }
                _this.$message.success('已保存');
                _this.fetchOrders();
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '保存失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.pendingSubmitReviewSaving = false;
            });
        },
        submitPendingSubmitReviewDialog() {
            var _this = this;
            if (!this.pendingSubmitReviewOrderId || !this.pendingSubmitReviewRowSnapshot) {
                this.$message.error('订单信息缺失');
                return;
            }
            var flags = this.encodePendingSubmitSignSelections(this.pendingSubmitReviewSelections);
            if (!flags) {
                this.$message.warning('请至少选择一项');
                return;
            }

            var row = this.pendingSubmitReviewRowSnapshot;
            var taxAccount = row.tax_account_status != null ? Number(row.tax_account_status) : 0;
            var taxLogin = row.tax_login_mode ? String(row.tax_login_mode) : '';
            if (!taxAccount || !taxLogin) {
                this.$message.warning('订单税务信息不完整，无法提交审核');
                return;
            }

            this.pendingSubmitReviewSubmitting = true;
            window.axios.put('/orders/' + this.pendingSubmitReviewOrderId + '/submit-review', {
                submit_sign_status: flags,
                tax_account_status: taxAccount,
                tax_login_mode: taxLogin,
                tax_progress_status: 4,
                tax_note: row.tax_note != null ? String(row.tax_note) : '',
                tax_portal_url: row.tax_portal_url || ''
            }).then(function () {
                _this.$message.success('已提交到审核中');
                _this.pendingSubmitReviewDialogVisible = false;
                _this.fetchOrders();
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '提交失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.pendingSubmitReviewSubmitting = false;
            });
        },
        advancePublicityToPendingSubmitTest(row) {
            var _this = this;
            if (!row || !row.id || !this.isPublicityTable) {
                return;
            }
            this.advancingPublicityTestOrderId = Number(row.id);
            window.axios.put('/orders/' + row.id + '/biz', {
                biz_progress_status: 103,
                biz_authorization_status: row.biz_authorization_status != null ? Number(row.biz_authorization_status) : 0,
                biz_license_status: row.biz_license_status != null ? Number(row.biz_license_status) : 1,
                biz_annual_report_status: row.biz_annual_report_status != null ? Number(row.biz_annual_report_status) : 0,
                biz_note: row.biz_note != null ? String(row.biz_note) : '',
                biz_portal_url: row.biz_portal_url || ''
            }).then(function () {
                _this.$message.success('测试流转成功，已转入待提交');
                _this.fetchOrders();
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '测试流转失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.advancingPublicityTestOrderId = null;
            });
        },
        mapAnnualReportStageToBizAnnualStatus(stage) {
            var map = {
                1: 1,
                2: 2,
                3: 1,
                4: 1
            };
            return map[Number(stage)] || 0;
        },
        handleBizProgressStatusChange(value) {
            if (Number(value) !== 102) {
                this.progressForm.announcement_end_date = '';
            }
        },
        taxSituationTooltipText(row) {
            return '';
        },
        bizSituationTooltipText(row) {
            return '';
        },
        formatBizLicenseLabel(status) {
            var map = {
                0: '未公告',
                1: '已公告',
                2: '异常',
                3: '待公告'
            };
            return map[Number(status)] || '--';
        },
        goOrderDetailFocus(row, focus) {
            if (!row || !row.id || !this.$router) {
                return;
            }

            var query = focus ? { focus: focus } : {};
            this.$router.push({ path: '/orders/' + row.id, query: query });
        },
        /** 已清税列表进工商注销页签，其余列表进税务流程 */
        goOrderDetailProgress(row) {
            var focus = this.isTaxClearedTable ? 'biz' : 'process';
            this.goOrderDetailFocus(row, focus);
        },
        handleCreated(order) {
            this.createDialogVisible = false;
            this.$message.success('新增订单成功');
            this.fetchOrders();
            this.$emit('created', order);
        },
        openEditDialog(row) {
            this.currentOrderId = row && row.id ? row.id : null;
            this.editDialogVisible = true;
            this.fetchEditDialogDetail();
        },
        handleEditSaved() {
            this.$message.success('修改保存成功');
            this.editDialogVisible = false;
            this.fetchOrders();
        },
        fetchEditDialogDetail() {
            var _this = this;
            if (!this.currentOrderId) {
                return;
            }

            this.editLoading = true;
            window.axios.get('/orders/' + this.currentOrderId).then(function (response) {
                var data = response.data.data || {};
                var company = data.company || {};
                var financial = data.financial || {};
                _this.editCreateInitialForm = {
                    company: {
                        name: company.name || '',
                        entity_type: company.entity_type != null ? Number(company.entity_type) : 1,
                        credit_code: company.credit_code || '',
                        legal_name: company.legal_name || '',
                        legal_id_no: company.legal_id_no || '',
                        phone: company.phone || '',
                        province: company.province || '广东省',
                        announcement_end_date: company.announcement_end_date || _this.todayDateString()
                    },
                    order: {
                        is_work_enabled: data.is_work_enabled != null ? Number(data.is_work_enabled) : 0,
                        is_channel_order: data.is_channel_order != null ? Number(data.is_channel_order) : 0,
                        channel_id: data.channel_id != null ? Number(data.channel_id) : null,
                        channel_code: data.channel_code || '',
                        channel_name: data.channel_name || '',
                        tax_account_status: data.tax_account_status != null ? Number(data.tax_account_status) : 1,
                        biz_announcement_status: data.biz_announcement_status != null ? Number(data.biz_announcement_status) : 1,
                        annual_report_stage: data.annual_report_stage != null ? Number(data.annual_report_stage) : 1
                    },
                    financial: {
                        receivable_total: financial.receivable_total != null ? Number(financial.receivable_total) : 0,
                        paid_total: financial.paid_total != null ? Number(financial.paid_total) : 0,
                        payment_type: financial.payment_type != null ? Number(financial.payment_type) : 1,
                        remark: financial.remark || '',
                        channel_payable_total: financial.channel_payable_total != null ? Number(financial.channel_payable_total) : 0,
                        channel_paid_total: financial.channel_paid_total != null ? Number(financial.channel_paid_total) : 0
                    }
                };
            }).catch(function () {
                _this.$message.error('加载修改信息失败');
            }).finally(function () {
                _this.editLoading = false;
            });
        },
        submitEditDialog() {
            var _this = this;
            if (!this.currentOrderId) {
                this.$message.error('订单信息缺失');
                return;
            }

            this.$refs.editFormRef.validate(function (valid) {
                if (!valid) {
                    return false;
                }

                _this.editSubmitting = true;

                var receiptPayload = {
                    company: {
                        name: _this.editForm.company.name,
                        credit_code: _this.editForm.company.credit_code,
                        legal_name: _this.editForm.company.legal_name,
                        legal_id_no: _this.editForm.company.legal_id_no,
                        phone: _this.editForm.company.phone
                    }
                };

                window.axios.put('/orders/' + _this.currentOrderId + '/receipt', receiptPayload).then(function () {
                    _this.$message.success('修改保存成功');
                    _this.editDialogVisible = false;
                    _this.fetchOrders();
                }).catch(function (error) {
                    var data = error && error.response && error.response.data ? error.response.data : null;
                    var message = data && data.message ? data.message : '修改保存失败';
                    if (data && data.errors && typeof data.errors === 'object') {
                        var keys = Object.keys(data.errors);
                        if (keys.length && data.errors[keys[0]] && data.errors[keys[0]][0]) {
                            message = message + '（' + data.errors[keys[0]][0] + '）';
                        }
                    }
                    if (error && error.response && error.response.status === 403 && data && data.required_permissions) {
                        message = message + ' 缺少权限：' + data.required_permissions.join('、');
                    }
                    _this.$message.error(message);
                }).finally(function () {
                    _this.editSubmitting = false;
                });
            });
        },
        groupEditExistingAttachments(remarks) {
            var groups = {
                taxClearance: [],
                idCardFront: [],
                idCardBack: [],
                bizSimpleCommitment: [],
                creditRepairApplication: [],
                creditRepairCommitment: [],
                licenseLossNotice: []
            };
            (remarks || []).forEach(function (remark) {
                var attachments = remark && remark.attachments ? remark.attachments : [];
                if (remark.remark_type === '税务清税证明' || remark.remark_type === '清税证明') {
                    groups.taxClearance = groups.taxClearance.concat(attachments);
                } else if (remark.remark_type === '身份证正面' || remark.remark_type === '老板身份证正面照片') {
                    groups.idCardFront = groups.idCardFront.concat(attachments);
                } else if (remark.remark_type === '身份证背面') {
                    groups.idCardBack = groups.idCardBack.concat(attachments);
                } else if (remark.remark_type === '投资人承诺书' || remark.remark_type === '简易注销投资人承诺书') {
                    groups.bizSimpleCommitment = groups.bizSimpleCommitment.concat(attachments);
                } else if (remark.remark_type === '信用修复申请书') {
                    groups.creditRepairApplication = groups.creditRepairApplication.concat(attachments);
                } else if (remark.remark_type === '信用修复承诺书') {
                    groups.creditRepairCommitment = groups.creditRepairCommitment.concat(attachments);
                } else if (remark.remark_type === '执照遗失公告') {
                    groups.licenseLossNotice = groups.licenseLossNotice.concat(attachments);
                }
            });
            return groups;
        },
        downloadAttachmentAs(file, label, targetFormat, companyNameOverride, orderIdOverride) {
            var _this = this;
            var orderId = orderIdOverride || this.currentOrderId || this.attachmentOrderId;
            if (!orderId || !file || !file.id) {
                return;
            }

            window.axios.get('/orders/' + orderId + '/remarks/attachments/' + file.id, {
                responseType: 'blob'
            }).then(function (response) {
                var sourceType = String(file.mime_type || '').toLowerCase();
                var isImage = sourceType.indexOf('image/') === 0 || ['jpg', 'jpeg', 'png', 'webp'].indexOf(String(file.file_ext || '').toLowerCase()) > -1;
                var isPdf = sourceType.indexOf('application/pdf') > -1 || String(file.file_ext || '').toLowerCase() === 'pdf';
                var blob = response.data;

                if (targetFormat === 'pdf' && !isPdf) {
                    _this.$message.warning('当前附件不支持转换为 PDF，请先上传 PDF 文件后下载。');
                    return;
                }
                if (targetFormat === 'jpg' && !isImage) {
                    _this.$message.warning('当前附件不支持转换为 JPG，请先上传图片文件后下载。');
                    return;
                }

                if (targetFormat === 'jpg') {
                    _this.convertImageBlobToJpg(blob).then(function (jpgBlob) {
                        _this.saveBlobWithName(jpgBlob, _this.buildDownloadFileName(label, 'jpg', companyNameOverride));
                    }).catch(function () {
                        _this.$message.error('JPG 下载失败');
                    });
                    return;
                }

                _this.saveBlobWithName(blob, _this.buildDownloadFileName(label, 'pdf', companyNameOverride));
            }).catch(function () {
                _this.$message.error('附件下载失败');
            });
        },
        deleteEditAttachment(file) {
            var _this = this;
            if (!this.currentOrderId || !file || !file.id) {
                return;
            }

            this.$confirm('确认删除该附件吗？', '删除附件', { type: 'warning' }).then(function () {
                return window.axios.delete('/orders/' + _this.currentOrderId + '/remarks/attachments/' + file.id).then(function () {
                    _this.$message.success('附件删除成功');
                    return _this.fetchEditDialogDetail();
                }).catch(function (error) {
                    var message = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : '附件删除失败';
                    _this.$message.error(message);
                });
            }).catch(function () {
            });
        },
        buildDownloadFileName(label, ext, companyNameOverride) {
            var companyName = companyNameOverride
                ? String(companyNameOverride)
                : (this.editForm && this.editForm.company && this.editForm.company.name ? this.editForm.company.name : '公司');
            return companyName + label + '.' + ext;
        },
        convertImageBlobToJpg(blob) {
            return new Promise(function (resolve, reject) {
                var reader = new window.FileReader();
                reader.onload = function () {
                    var image = new window.Image();
                    image.onload = function () {
                        var canvas = document.createElement('canvas');
                        canvas.width = image.width;
                        canvas.height = image.height;
                        var ctx = canvas.getContext('2d');
                        ctx.fillStyle = '#ffffff';
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                        ctx.drawImage(image, 0, 0);
                        canvas.toBlob(function (jpgBlob) {
                            if (!jpgBlob) {
                                reject(new Error('convert failed'));
                                return;
                            }
                            resolve(jpgBlob);
                        }, 'image/jpeg', 0.92);
                    };
                    image.onerror = reject;
                    image.src = reader.result;
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        saveBlobWithName(blob, fileName) {
            var blobUrl = window.URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        },
        formatAmount(value) {
            var amount = Number(value || 0);
            if (!isFinite(amount)) {
                return '0.00';
            }
            return amount.toFixed(2);
        },
        handleDelete(row) {
            if (this.isDispatchBizOnlySpecialist) {
                return;
            }
            var _this = this;
            this.$confirm('删除后订单将不再显示，是否继续？', '确认删除', {
                type: 'warning'
            }).then(function () {
                return window.axios.delete('/orders/' + row.id).then(function () {
                    _this.$message.success('删除成功');
                    _this.fetchOrders();
                }).catch(function (error) {
                    var message = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : '删除失败';
                    _this.$message.error(message);
                });
            }).catch(function () {
            });
        },
        openDispatchDialog(row) {
            this.dispatchForm = {
                order_id: row && row.id ? row.id : null,
                receiver_user_id: null,
                remark: ''
            };
            this.dispatchDialogVisible = true;
            this.fetchDispatchReceivers();
            this.$nextTick(function () {
                if (this.$refs.dispatchFormRef) {
                    this.$refs.dispatchFormRef.clearValidate();
                }
            });
        },
        fetchDispatchReceivers() {
            var _this = this;
            this.dispatchReceiversLoading = true;

            window.axios.get('/dispatch/receivers', {
                params: {
                    dispatch_scope: 0
                }
            }).then(function (response) {
                _this.dispatchReceivers = response.data.data || [];
            }).catch(function () {
                _this.$message.error('接收人员加载失败');
                _this.dispatchReceivers = [];
            }).finally(function () {
                _this.dispatchReceiversLoading = false;
            });
        },
        submitDispatch() {
            var _this = this;
            if (!this.dispatchForm.order_id) {
                this.$message.error('订单信息缺失，无法外派');
                return;
            }

            this.$refs.dispatchFormRef.validate(function (valid) {
                if (!valid) {
                    return false;
                }

                _this.dispatchSubmitting = true;
                window.axios.put('/orders/' + _this.dispatchForm.order_id + '/dispatch', {
                    receiver_user_id: _this.dispatchForm.receiver_user_id,
                    dispatch_scope: 0,
                    remark: _this.dispatchForm.remark || ''
                }).then(function () {
                    _this.$message.success('外派分派成功');
                    _this.dispatchDialogVisible = false;
                    _this.fetchOrders();
                }).catch(function (error) {
                    var message = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : '外派分派失败';
                    _this.$message.error(message);
                }).finally(function () {
                    _this.dispatchSubmitting = false;
                });
            });
        },
        cancelDispatchInDialog() {
            var _this = this;
            if (!this.dispatchForm.order_id) {
                this.$message.error('订单信息缺失，无法取消外派');
                return;
            }
            this.$confirm('确认取消该订单外派吗？', '提示', {
                type: 'warning'
            }).then(function () {
                _this.dispatchCancelling = true;
                return window.axios.put('/orders/' + _this.dispatchForm.order_id + '/dispatch/recall');
            }).then(function () {
                _this.$message.success('已取消外派');
                _this.dispatchDialogVisible = false;
                _this.fetchOrders();
            }).catch(function (error) {
                if (error === 'cancel') {
                    return;
                }
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '取消外派失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.dispatchCancelling = false;
            });
        },
        setWorkEnabled(row, enabled) {
            var _this = this;
            if (!row || !row.id) {
                return;
            }

            var on = Number(enabled) === 1;
            var f = row.financial || {};
            var w = row.work || {};
            var payload = {
                is_work_enabled: on ? 1 : 0,
                field_payable_total: f.field_payable_total != null ? Number(f.field_payable_total) : 0,
                field_paid_total: f.field_paid_total != null ? Number(f.field_paid_total) : 0
            };
            if (!on) {
                payload.field_partner_id = null;
            } else {
                payload.field_partner_id = w.field_partner_id != null ? Number(w.field_partner_id) : null;
                if (!payload.field_partner_id) {
                    this.$message.warning('请先在「外勤」弹窗中选择合作外勤后再开启');
                    return;
                }
            }

            window.axios.put('/orders/' + row.id + '/field-work', payload).then(function () {
                _this.$message.success('外勤单状态更新成功');
                _this.fetchOrders();
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '外勤单状态更新失败';
                _this.$message.error(message);
            });
        },
        handleWorkEnabledChange(row, value) {
            this.setWorkEnabled(row, value ? 1 : 0);
        },
        formatDispatchReceiverLabel(user) {
            var name = user && user.name ? String(user.name).trim() : '';
            var username = user && user.username ? String(user.username).trim() : '';
            var roles = user && user.roles && Array.isArray(user.roles) ? user.roles : [];
            var dispatchCodes = ['dispatch-specialist-tax', 'dispatch-specialist-biz', 'dispatch-specialist-both'];
            var targetRole = roles.find(function (r) {
                var code = r && r.code ? String(r.code).trim() : '';
                return dispatchCodes.indexOf(code) >= 0;
            }) || roles[0] || null;
            var roleCode = targetRole && targetRole.code ? String(targetRole.code).trim() : '';
            var roleName = targetRole && targetRole.name ? String(targetRole.name).trim() : '';
            if (roleCode === 'dispatch-specialist-both') {
                roleName = '外派专员-税工';
            } else if (roleCode === 'dispatch-specialist-tax') {
                roleName = '外派专员-仅税务';
            } else if (roleCode === 'dispatch-specialist-biz') {
                roleName = '外派专员-仅工商';
            }
            var phone = user && user.phone ? String(user.phone).trim() : '';
            var displayName = name || username;

            if (!displayName) {
                return '--';
            }
            if (roleName) {
                return displayName + '-' + roleName;
            }
            if (phone) {
                return displayName + '-' + phone;
            }
            return displayName;
        },
        clampOrderPage() {
            var total = (this.orders || []).length;
            var per = this.orderPerPage || 10;
            var lastPage = Math.max(1, Math.ceil(total / per) || 1);
            if (this.orderPage > lastPage) {
                this.orderPage = lastPage;
            }
        },
        handleOrderPageChange(p) {
            this.orderPage = p;
            this.syncOrderTableCurrentRow();
        },
        handleOrderPageSizeChange(size) {
            this.orderPerPage = size;
            this.orderPage = 1;
            this.syncOrderTableCurrentRow();
        },
        syncOrderTableCurrentRow() {
            var _this = this;
            this.$nextTick(function () {
                var r = _this.selectedOrderRow;
                if (!r || !r.id || !_this.$refs.ordersTableRef || !_this.$refs.ordersTableRef.setCurrentRow) {
                    return;
                }
                var shown = _this.displayedOrders.some(function (row) {
                    return Number(row.id) === Number(r.id);
                });
                if (!shown) {
                    _this.$refs.ordersTableRef.setCurrentRow();
                }
            });
        },
        resetToolbarSearch() {
            this.filters.keyword = '';
            this.filters.publicity_end_date = '';
            this.orderPage = 1;
            this.selectedOrderRow = null;
            this.fetchOrders();
        },
        fetchOrders() {
            var _this = this;
            var params = Object.assign({}, this.extraQueryParams);

            if (this.filters.keyword) {
                params.keyword = this.filters.keyword;
            }

            if (this.filters.publicity_end_date) {
                params.publicity_end_date = this.filters.publicity_end_date;
            }

            this.loading = true;

            window.axios.get('/orders', {
                params: params
            }).then(function (response) {
                _this.orders = response.data.data || [];
                _this.$nextTick(function () {
                    _this.clampOrderPage();
                    _this.syncOrderTableCurrentRow();
                });
            }).catch(function () {
                _this.$message.error('订单列表加载失败');
                _this.orders = [];
            }).finally(function () {
                _this.loading = false;
            });
        },
        exportOrders() {
            var params = Object.assign(
                {
                    keyword: this.filters.keyword || ''
                },
                this.extraQueryParams
            );

            window.axios.get('/exports/orders', {
                params: params,
                responseType: 'blob'
            }).then(function (response) {
                var blobUrl = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement('a');
                link.href = blobUrl;
                link.download = 'orders-export.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            });
        },
        exportArchivedOrdersBasic() {
            var _this = this;
            var params = {
                keyword: this.filters.keyword || '',
                is_archived: 1
            };
            this.archivedBasicExporting = true;
            window.axios.get('/exports/completed-orders-basic', {
                params: params,
                responseType: 'blob'
            }).then(function (response) {
                var blobUrl = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement('a');
                link.href = blobUrl;
                link.download = 'completed-orders-basic.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
                _this.$message.success('导出成功');
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '导出失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.archivedBasicExporting = false;
            });
        },
        sendArchivedCompletionNoticeSms(row) {
            var _this = this;
            if (!row || !row.id) {
                return;
            }
            var id = Number(row.id);
            this.$confirm(
                '将向法人手机号发送「注销完成」类通知（具体文案与通道由系统短信配置决定），是否继续？',
                '发送通知',
                {
                    confirmButtonText: '发送',
                    cancelButtonText: '取消',
                    type: 'info'
                }
            ).then(function () {
                _this.completionSmsOrderId = id;
                return window.axios.post('/orders/' + id + '/completion-notice-sms');
            }).then(function (response) {
                var msg = response.data && response.data.message ? response.data.message : '已提交';
                _this.$message.success(msg);
            }).catch(function (err) {
                if (err === 'cancel') {
                    return;
                }
                var message = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : '发送失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.completionSmsOrderId = null;
            });
        },
        getRowStyle(rowInfo) {
            var colorMap = {
                red: '#fdecea',
                yellow: '#fff8e1',
                green: '#edf7ed'
            };

            return {
                backgroundColor: colorMap[rowInfo.row.status_color] || '#ffffff'
            };
        },
        formatDate(value) {
            if (!value) {
                return '--';
            }

            return String(value).slice(0, 10);
        },
        listDisplayDate(row) {
            if (row.receipt_date) {
                return row.receipt_date;
            }

            return this.formatDate(row.created_at);
        },
        formatBizAnnouncementLabel(status) {
            var map = {
                1: '正常',
                2: '撤销',
                3: '吊销'
            };

            return map[Number(status)] || '--';
        },
        formatAnnualReportStageLabel(stage) {
            var map = {
                1: '正常',
                2: '逾期申报',
                3: '已补报',
                4: '已修复'
            };

            return map[Number(stage)] || '--';
        },
        formatTaxAccountStatusLabel(status) {
            var map = {
                1: '正常户',
                2: '非正常户'
            };

            return map[Number(status)] || '--';
        },
        taxProgressTooltipText(row) {
            if (!row || row.tax_note == null) {
                return '';
            }
            return String(row.tax_note).trim();
        },
        bizProgressTooltipText(row) {
            if (!row || row.biz_note == null) {
                return '';
            }
            return String(row.biz_note).trim();
        },
        formatTaxProgressLabel(status) {
            var n = Number(status);
            if (n === 2) {
                return '税务未开';
            }
            var map = {
                1: '税务未开',
                3: '清税中',
                4: '已清税'
            };

            return map[n] || '--';
        },
        formatSubmitSignStatusLabel(status) {
            var n = Number(status || 0);
            if (!n) {
                return '--';
            }
            var parts = [];
            if ((n & 1) === 1) {
                parts.push('待签字');
            }
            if ((n & 2) === 2) {
                parts.push('已签字');
            }
            if ((n & 4) === 4) {
                parts.push('已核名');
            }
            return parts.length ? parts.join('，') : '--';
        },
        displayTaxProgressLabel(row) {
            if (!row) {
                return '--';
            }
            // 待办件：未在「进度」中维护税务信息前（无税务情况/税登方式，且进度仍为默认 1）三列均与「--」一致
            if (this.isTodoTable) {
                var accountStatus = Number(row.tax_account_status || 0);
                var progressStatus = row.tax_progress_status != null ? Number(row.tax_progress_status) : 0;
                var loginMode = row.tax_login_mode ? String(row.tax_login_mode) : '';
                var uninitialized = (accountStatus === 0 || !accountStatus) && (loginMode === '' || loginMode === '0');
                if (uninitialized && (progressStatus === 0 || progressStatus === 1)) {
                    return '--';
                }
            }

            return this.formatTaxProgressLabel(row.tax_progress_status);
        },
        displayBizProgressLabel(row) {
            if (!row) {
                return '--';
            }
            // 驳回单：从审核中驳回移入后，工商进度列固定为「已驳回」（库内可能为 104 异常态）
            if (this.isRejectResubmitListTable) {
                return '已驳回';
            }
            var announcement = Number(row.biz_announcement_status || 0);
            var annual = Number(row.annual_report_stage || 0);
            var license = Number(row.biz_license_status || 0);
            var progress = Number(row.biz_progress_status || 0);
            var uninitialized = (announcement === 0) && (annual === 0) && (license === 9) && (progress === 101);
            if (uninitialized) {
                return '--';
            }
            return this.formatBizProgressLabel(progress);
        },
        formatTotalCancellationProgressLabel(row) {
            if (!row) {
                return '--';
            }
            // 驳回单：从审核中驳回后本列固定为「--」，签字/核名进度仍在「进度」弹窗中查看
            if (this.isRejectResubmitListTable) {
                return '--';
            }
            // 待提交 / 审核中：本列展示「进度」弹窗中的勾选文案，横向一行（多项用中文逗号连接）
            return this.formatSubmitSignStatusLabel(row.submit_sign_status);
        },
        totalCancellationProgressTooltipText(row) {
            if (!row) {
                return '';
            }
            var parts = [];
            var taxNote = row.tax_note != null ? String(row.tax_note).trim() : '';
            var bizNote = row.biz_note != null ? String(row.biz_note).trim() : '';
            var signLabel = this.formatSubmitSignStatusLabel(row.submit_sign_status);
            if (signLabel && signLabel !== '--') {
                parts.push('签字进度：' + signLabel);
            }
            if (taxNote) {
                parts.push('税务备注：' + taxNote);
            }
            if (bizNote) {
                parts.push('工商备注：' + bizNote);
            }
            return parts.join('\n');
        },
        /** 快登链接：已清税/公示中走工商入口，其它列表走税务入口 */
        getQuickLinkButtonLabel(row) {
            var province = row && row.company && row.company.province ? String(row.company.province).trim() : '';
            return province || '税务';
        },
        quickLinkUrl(row) {
            if (!row) {
                return '';
            }
            if (this.isTaxClearedTable || this.isPublicityTable || this.showAnnouncementColumns || this.isPendingSubmitTable) {
                return row.biz_portal_url || '';
            }
            return row.tax_portal_url || '';
        },
        quickLinkTooltip(row) {
            if (!row) {
                return '';
            }
            if (this.isTaxClearedTable || this.isPublicityTable || this.showAnnouncementColumns || this.isPendingSubmitTable) {
                return row.biz_portal_url ? '工商快登' : '';
            }
            if (row.tax_portal_url) {
                return '税务快登';
            }
            return '';
        },
        formatBizProgressLabel(status) {
            var map = {
                101: '办理中',
                102: '公示中',
                103: '待提交',
                104: '异常'
            };

            return map[Number(status)] || '--';
        },
        formatProcessStatusLabel(status) {
            var map = {
                1: '待开始',
                2: '办理中',
                3: '已完成',
                4: '异常'
            };

            return map[Number(status)] || '--';
        },
        formatAuthorizationLabel(status) {
            var map = {
                0: '待授权',
                1: '已授权',
                2: '授权异常'
            };

            return map[Number(status)] || '--';
        },
        getProcessTrack(row, node) {
            var tracks = row.process_tracks || [];

            for (var index = 0; index < tracks.length; index += 1) {
                if (Number(tracks[index].process_node) === Number(node)) {
                    return tracks[index];
                }
            }

            return null;
        }
    }
};
</script>

<style scoped>
.order-workbench {
    border: 1px solid #eef2f7;
}

.order-workbench__company-name-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 6px;
}

.order-workbench__badge-tooltip-trigger {
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
}

/* 勤 / 派：字号与字重一致 */
.order-workbench__field-badge,
.order-workbench__dispatch-badge {
    flex-shrink: 0;
    font-size: 12px !important;
    font-weight: normal !important;
}

/* 勤：白底 + 橘色细边框 + 橘色字（覆盖 warning plain 默认浅底） */
.order-workbench__field-badge {
    background-color: #fff !important;
    border: 1px solid #e6a23c !important;
    color: #e6a23c !important;
}

/* 派：浅绿底 + 绿色细边框 + 绿色字 */
.order-workbench__dispatch-badge {
    background-color: #e8f5e9 !important;
    border: 1px solid #43a047 !important;
    color: #2e7d32 !important;
}

.order-workbench__tax-progress-cell--hint {
    cursor: help;
    border-bottom: 1px dashed #c0c4cc;
}

.order-workbench__header {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
}

.order-workbench__title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
}

.order-workbench__toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
}

.order-workbench__toolbar--titled {
    padding-top: 4px;
}

.order-workbench__toolbar-leading {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    padding-right: 8px;
}

.order-workbench__create-btn {
    width: auto;
    max-width: none;
}

.order-workbench__entry-btn--national-tax {
    background-color: #0284c7;
    border-color: #0284c7;
}

.order-workbench__entry-btn--national-tax:hover,
.order-workbench__entry-btn--national-tax:focus {
    background-color: #0369a1;
    border-color: #0369a1;
}

.order-workbench__entry-btn--qcc {
    background-color: #14b8a6;
    border-color: #14b8a6;
}

.order-workbench__entry-btn--qcc:hover,
.order-workbench__entry-btn--qcc:focus {
    background-color: #0d9488;
    border-color: #0d9488;
}

.order-workbench__entry-btn--publicity {
    background-color: #8b5cf6;
    border-color: #8b5cf6;
}

.order-workbench__entry-btn--publicity:hover,
.order-workbench__entry-btn--publicity:focus {
    background-color: #7c3aed;
    border-color: #7c3aed;
}

.order-workbench__toolbar-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    flex: 1;
    min-width: 0;
    justify-content: flex-end;
}

.order-workbench__toolbar-actions--stretch {
    justify-content: flex-end;
    width: 100%;
}

.order-workbench__search {
    width: 360px;
}

.order-workbench__selected-hint {
    display: inline-flex;
    align-items: center;
    height: 32px;
    padding: 0 10px;
    border-radius: 4px;
    background: #ecf5ff;
    border: 1px solid #b3d8ff;
    color: #409eff;
    font-size: 12px;
    white-space: nowrap;
}

.order-workbench__note-tooltip-content {
    white-space: pre-line;
    word-break: break-word;
    max-width: 320px;
    line-height: 1.5;
}

.order-workbench__pending-review-title {
    margin-bottom: 10px;
    color: #606266;
    font-size: 13px;
    line-height: 1.6;
}

.order-workbench__pending-review-item {
    padding: 6px 0;
}

.order-workbench__pending-review--in-progress-dialog {
    margin-bottom: 16px;
}

.order-workbench__total-cancel-progress-cell {
    display: inline;
    white-space: normal;
    word-break: keep-all;
    line-height: 1.45;
}

.order-workbench__multiline-cell {
    display: block;
    white-space: pre-line;
    line-height: 1.45;
}

.order-workbench >>> .order-workbench__note-tooltip.el-tooltip__popper.is-dark,
.order-workbench ::v-deep .order-workbench__note-tooltip.el-tooltip__popper.is-dark {
    background: #909399;
}

.order-workbench >>> .order-workbench__note-tooltip.el-tooltip__popper.is-dark[x-placement^='top'] .popper__arrow::after,
.order-workbench ::v-deep .order-workbench__note-tooltip.el-tooltip__popper.is-dark[x-placement^='top'] .popper__arrow::after {
    border-top-color: #909399;
}

.order-workbench__receipt-pending-input >>> .el-input__inner,
.order-workbench__receipt-pending-input ::v-deep .el-input__inner {
    text-align: center !important;
}

.order-workbench__receipt-pending-item >>> .el-form-item__content,
.order-workbench__receipt-pending-item ::v-deep .el-form-item__content {
    text-align: center;
}

.order-workbench__receipt-pending-input {
    width: 100%;
}

.full-width {
    width: 100%;
}

.order-workbench__table {
    width: 100%;
}

.order-workbench__pager {
    margin-top: 12px;
    text-align: right;
}

.order-workbench >>> .el-table td,
.order-workbench ::v-deep .el-table td {
    vertical-align: middle;
}

.order-workbench >>> .el-table .cell,
.order-workbench ::v-deep .el-table .cell {
    padding-left: 10px;
    padding-right: 10px;
}

.order-workbench >>> .order-workbench__table--auto .order-workbench-col--company-name .cell,
.order-workbench ::v-deep .order-workbench__table--auto .order-workbench-col--company-name .cell,
.order-workbench >>> .order-workbench__table--auto .order-workbench-col--credit-code .cell,
.order-workbench ::v-deep .order-workbench__table--auto .order-workbench-col--credit-code .cell {
    white-space: normal;
    line-height: 1.35;
    word-break: break-all;
}

/* 双击复制时不显示浏览器文本选中背景 */
.order-workbench >>> .el-table__body td,
.order-workbench ::v-deep .el-table__body td {
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

/* Element UI 默认 .cell 为 nowrap，会导致「操作」两排按钮被压成一行 */
.order-workbench >>> .order-workbench-col--actions .cell,
.order-workbench ::v-deep .order-workbench-col--actions .cell {
    white-space: normal;
    overflow: visible;
    line-height: 1.5;
}

.order-workbench >>> .el-table__body tr.order-workbench__row-selected > td,
.order-workbench ::v-deep .el-table__body tr.order-workbench__row-selected > td {
    background-color: #d9ecff !important;
}

.order-workbench__row-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.3px;
}

.order-workbench__row-actions-line {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 1px 2px;
    justify-content: center;
}

.order-workbench__receipt-link--uncollected.el-button--text {
    color: #f56c6c !important;
}

.order-workbench__receipt-link--partial.el-button--text {
    color: #e6a23c !important;
}

.order-workbench__receipt-link--full.el-button--text {
    color: #67c23a !important;
}

.order-workbench__receipt-link--neutral.el-button--text {
    color: #909399 !important;
}

.order-workbench__action-link--fixed-disabled.el-button--text,
.order-workbench__action-link--fixed-disabled.el-button--text.is-disabled {
    color: #c0c4cc !important;
    cursor: not-allowed !important;
}

.order-workbench__row-actions-stack {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.order-workbench__quick-links {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
}

.order-workbench__cell-center {
    display: flex;
    justify-content: center;
}

.order-workbench__action-btn--large {
    font-size: 13px;
    font-weight: 500;
}

.order-workbench__attachment-list {
    margin-top: 6px;
    color: #606266;
    font-size: 12px;
}

.order-workbench__attachment-actions {
    margin-top: 6px;
}

.order-workbench__attachment-action-row {
    display: flex;
    align-items: center;
    gap: 6px;
    line-height: 1.4;
}

.order-workbench__attachment-file-name {
    display: inline-block;
    max-width: 180px;
    color: #606266;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.order-workbench__switch-wrap {
    display: flex;
    justify-content: center;
}


</style>

<style>
/* 待办件工具栏：新增 / 修改 / 外勤 / 派单 弹窗统一外观（append-to-body，需非 scoped） */
.el-dialog.order-workbench-hub-dialog {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(15, 23, 42, 0.1);
    margin-top: 5vh !important;
    margin-bottom: 5vh !important;
    box-sizing: border-box;
}

.el-dialog.order-workbench-hub-dialog .order-workbench-hub-dialog__body-inner {
    min-height: 0;
}

.el-dialog.order-workbench-hub-dialog.order-workbench-hub-dialog--w-lg {
    width: min(1020px, calc(100vw - 24px)) !important;
    max-width: calc(100vw - 24px) !important;
}

.el-dialog.order-workbench-hub-dialog.order-workbench-hub-dialog--w-md {
    width: min(900px, calc(100vw - 24px)) !important;
    max-width: calc(100vw - 24px) !important;
}

/* 外勤订单：约为原 w-md（900px）的一半，小屏仍留边距 */
.el-dialog.order-workbench-hub-dialog.order-workbench-hub-dialog--w-field {
    width: min(450px, calc(100vw - 24px)) !important;
    max-width: calc(100vw - 24px) !important;
}

.el-dialog.order-workbench-hub-dialog.order-workbench-hub-dialog--w-sm {
    width: min(560px, calc(100vw - 24px)) !important;
    max-width: calc(100vw - 24px) !important;
}

.el-dialog.order-workbench-hub-dialog .el-dialog__header {
    padding: 18px 22px 14px;
    background: linear-gradient(180deg, #f8fafc 0%, #fff 55%);
    border-bottom: 1px solid #eef0f4;
}

.el-dialog.order-workbench-hub-dialog .el-dialog__title {
    color: #303133;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 1.35;
}

.el-dialog.order-workbench-hub-dialog .el-dialog__body {
    padding: 18px 22px 20px;
    background: #fff;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: calc(90vh - 132px);
    box-sizing: border-box;
}

.el-dialog.order-workbench-hub-dialog .order-workbench-hub-dialog__form .el-form-item {
    margin-bottom: 16px;
}

.el-dialog.order-workbench-hub-dialog .order-workbench-hub-dialog__form .el-form-item:last-child {
    margin-bottom: 2px;
}

.el-dialog.order-workbench-hub-dialog .order-workbench-hub-dialog__form .el-form-item__label {
    color: #606266;
    font-size: 13px;
    font-weight: 500;
    line-height: 32px;
    padding-right: 10px;
}

.el-dialog.order-workbench-hub-dialog .el-dialog__footer {
    padding: 12px 22px 16px;
    background: #fafbfc;
    border-top: 1px solid #eef0f4;
}

.el-dialog.order-workbench-hub-dialog .order-workbench-hub-dialog__footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    width: 100%;
    box-sizing: border-box;
}

.el-dialog.order-workbench-hub-dialog .order-workbench-hub-dialog__footer .el-button {
    margin-left: 0 !important;
}

/* 新增 / 修改：表单底部按钮区与弹窗页脚视觉对齐 */
.el-dialog.order-workbench-hub-dialog .order-create-form--compact .order-create-form__actions {
    margin-top: 18px;
    padding-top: 14px;
    border-top: 1px solid #eef0f4;
}

.el-dialog.order-workbench-hub-dialog .el-dialog__headerbtn {
    top: 16px;
    right: 14px;
}

/* 收款弹窗 append-to-body，需非 scoped 才能作用到待收输入框 */
.order-workbench__receipt-dialog .order-workbench__receipt-pending-input.el-input .el-input__inner {
    text-align: center !important;
}

@keyframes order-workbench-review-stale-flash {
    0%,
    100% {
        background-color: transparent;
    }

    50% {
        background-color: rgba(245, 108, 108, 0.42);
    }
}

.el-table .order-workbench__row--review-stale-alert > td {
    animation: order-workbench-review-stale-flash 0.42s ease-in-out 10;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/OrderWorkbench.vue